// import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
// import '../styles/Documents.css';

// const MANDATORY_DOCUMENTS = [
//   "Duly signed copy of Offer Letter (Sign and scan all page into single PDF)",
//   "Employment Agreement (Sign and scan all page into single PDF)",
//   "Academic Qualification",
//   "Aadhar Card",
//   "Permanent Account Number (PAN)",
//   "Passport Size Photograph",
//   "Police verification (character certificate)",
//   "Salary slip of last 3 months",
//   "Bank Account Details",
//   "Medical checkup report"
// ];

// // Matrix Columns for Management Page 1 Overview
// const MATRIX_COLUMNS = [
//   { slot: 1, label: "OFFER LETTER", docType: "Duly signed copy of Offer Letter (Sign and scan all page into single PDF)" },
//   { slot: 2, label: "EMPLOYMENT AGREEMENT", docType: "Employment Agreement (Sign and scan all page into single PDF)" },
//   { slot: 3, label: "ACADEMIC QUALIF.", docType: "Academic Qualification" },
//   { slot: 4, label: "AADHAR CARD", docType: "Aadhar Card" },
//   { slot: 5, label: "PAN CARD", docType: "Permanent Account Number (PAN)" },
//   { slot: 6, label: "PASSPORT PHOTO", docType: "Passport Size Photograph" },
//   { slot: 7, label: "POLICE VERIF.", docType: "Police verification (character certificate)" },
//   { slot: 8, label: "SALARY SLIPS", docType: "Salary slip of last 3 months" },
//   { slot: 9, label: "BANK DETAILS", docType: "Bank Account Details" },
//   { slot: 10, label: "MEDICAL REPORT", docType: "Medical checkup report" }
// ];

// // Permanently excluded employees (never show in Documents UI or send emails)
// const EXCLUDED_EMAILS = [
//   'aaron.fisher@gtecorpgroup.com',
//   'aron.fisher@gtecorpgroup.com',
//   'sandeep.potti@gtecorpgroup.com'
// ];
// const EXCLUDED_NAMES = [
//   'aron fisher',
//   'aaron fisher',
//   'sandeep potti'
// ];

// const isExcludedEmployee = (emp) => {
//   if (!emp) return false;
//   const email = (emp.email || emp.EmailId || '').trim().toLowerCase();
//   if (email && EXCLUDED_EMAILS.includes(email)) return true;
//   const name = (emp.emp_name || emp.name || (emp.FirstName ? `${emp.FirstName} ${emp.LastName || ''}` : '')).trim().toLowerCase().replace(/\s+/g, ' ');
//   if (name && EXCLUDED_NAMES.includes(name)) return true;
//   return false;
// };

// // Dynamic API Base: Uses /gt-api on local development and /gt-api on server
// const DOCS_API_BASE = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
//   ? '/gt-api'
//   : '/gt-api';

// const Documents = ({ userData }) => {
//   const isManagement = userData?.role === 'Management' || userData?.role === 'Admin';
//   const currentEmpId = userData?.id || userData?.empId || userData?.EmpId;

//   // View mode: 'matrix' (Page 1) or 'detail' (Page 2)
//   // Management defaults to 'matrix'; regular employees always see their own 'detail'
//   const [viewMode, setViewMode] = useState(isManagement ? 'matrix' : 'detail');
//   const [matrixSearch, setMatrixSearch] = useState('');
//   const [matrixFilter, setMatrixFilter] = useState('all'); // 'all', 'pending', 'compliant', 'overdue'
//   const [departmentFilter, setDepartmentFilter] = useState('All'); // 'All' or specific department (Policy RnU style)

//   // Management State
//   const [employeesList, setEmployeesList] = useState([]);
//   const [selectedEmpId, setSelectedEmpId] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [mgmtLoading, setMgmtLoading] = useState(false);
//   const [bulkSending, setBulkSending] = useState(false);
//   const [bulkSuccess, setBulkSuccess] = useState(false);
//   const [bulkFeedback, setBulkFeedback] = useState(null);
//   const [sendingReminder, setSendingReminder] = useState(false);
//   const [reminderSuccess, setReminderSuccess] = useState(false);
//   const [reminderFeedback, setReminderFeedback] = useState(null);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const searchInputRef = useRef(null);

//   // Switch to Page 2 for selected employee
//   const handleOpenEmployeeDetail = (empId) => {
//     setSelectedEmpId(empId);
//     setViewMode('detail');
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Return to Page 1 Matrix Overview
//   const handleBackToMatrix = () => {
//     setViewMode('matrix');
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Reset email feedback when selected employee changes
//   useEffect(() => {
//     setReminderFeedback(null);
//     setReminderSuccess(false);
//   }, [selectedEmpId]);

//   // Active Employee Document Detail State
//   const [empData, setEmpData] = useState(null);
//   const [documents, setDocuments] = useState([]);
//   const [loadingDocs, setLoadingDocs] = useState(false);
//   const [uploadingDocType, setUploadingDocType] = useState(null);
//   const [togglingDocType, setTogglingDocType] = useState(null);
//   const [actionMessage, setActionMessage] = useState(null);

//   // Countdown timer state
//   const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

//   // Theme observer to detect light vs dark theme
//   const [isLightMode, setIsLightMode] = useState(() => {
//     return (
//       document.body.classList.contains('light-theme') ||
//       document.documentElement.classList.contains('light-theme') ||
//       document.documentElement.getAttribute('data-theme') === 'light' ||
//       localStorage.getItem('dashboard-theme') === 'light'
//     );
//   });

//   useEffect(() => {
//     const detectTheme = () => {
//       const isLight =
//         document.body.classList.contains('light-theme') ||
//         document.documentElement.classList.contains('light-theme') ||
//         document.documentElement.getAttribute('data-theme') === 'light' ||
//         localStorage.getItem('dashboard-theme') === 'light';
//       setIsLightMode(isLight);
//     };

//     detectTheme();

//     const observer = new MutationObserver(detectTheme);
//     observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
//     observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme'] });

//     window.addEventListener('storage', detectTheme);

//     return () => {
//       observer.disconnect();
//       window.removeEventListener('storage', detectTheme);
//     };
//   }, []);

//   // 1. FETCH ALL EMPLOYEES (FOR MANAGEMENT)
//   const fetchAllEmployees = useCallback(async () => {
//     if (!isManagement) return;
//     setMgmtLoading(true);
//     try {
//       const res = await fetch(`${DOCS_API_BASE}/get_employee_doc_status.php?all=1`);
//       const data = await res.json();
//       if (data.success) {
//         const cleanList = (data.employees || []).filter(e => !isExcludedEmployee(e));
//         setEmployeesList(cleanList);
//         // Kept empty by default until user chooses an employee from the dropdown
//       }
//     } catch (err) {
//       console.error("Error fetching employees document list:", err);
//     } finally {
//       setMgmtLoading(false);
//     }
//   }, [isManagement]);

//   useEffect(() => {
//     if (isManagement) {
//       fetchAllEmployees();
//     }
//   }, [fetchAllEmployees, isManagement]);

//   // 2. FETCH DOCUMENTS FOR TARGET EMPLOYEE
//   const targetEmpId = isManagement ? selectedEmpId : currentEmpId;

//   const fetchEmployeeDocuments = useCallback(async (empIdToFetch) => {
//     if (!empIdToFetch) {
//       setEmpData(null);
//       setDocuments([]);
//       return;
//     }
//     setLoadingDocs(true);
//     try {
//       const res = await fetch(`${DOCS_API_BASE}/get_employee_doc_status.php?emp_id=${encodeURIComponent(empIdToFetch)}`);
//       const data = await res.json();
//       if (data.success) {
//         if (isExcludedEmployee(data.employee)) {
//           setEmpData(null);
//           setDocuments([]);
//           return;
//         }
//         setEmpData(data.employee);
//         setDocuments(data.documents || []);
//       }
//     } catch (err) {
//       console.error("Error fetching employee documents:", err);
//     } finally {
//       setLoadingDocs(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (targetEmpId) {
//       fetchEmployeeDocuments(targetEmpId);
//     } else {
//       setEmpData(null);
//       setDocuments([]);
//     }
//   }, [targetEmpId, fetchEmployeeDocuments]);

//   // 3. LIVE COUNTDOWN TIMER TICKER
//   useEffect(() => {
//     if (!empData?.due_date) return;

//     const calculateTimeRemaining = () => {
//       let dateString = String(empData.due_date).trim();
//       if (dateString.includes(' ')) {
//         dateString = dateString.replace(' ', 'T');
//       } else if (!dateString.includes('T')) {
//         dateString = `${dateString}T23:59:59`;
//       }
//       const target = new Date(dateString).getTime();
//       const now = new Date().getTime();
//       const difference = target - now;

//       if (difference <= 0) {
//         setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
//       } else {
//         const days = Math.floor(difference / (1000 * 60 * 60 * 24));
//         const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//         const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
//         const seconds = Math.floor((difference % (1000 * 60)) / 1000);
//         setTimeLeft({ days, hours, minutes, seconds });
//       }
//     };

//     calculateTimeRemaining();
//     const interval = setInterval(calculateTimeRemaining, 1000);
//     return () => clearInterval(interval);
//   }, [empData?.due_date]);

//   // 4. HANDLE DOCUMENT UPLOAD (MANAGEMENT OR EMPLOYEE)
//   const handleFileUpload = async (docType, file) => {
//     if (!file) return;

//     setUploadingDocType(docType);
//     const uploaderName = `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim() || userData?.name || (isManagement ? 'Management' : 'Employee');
//     const uploaderEmail = userData?.EmailId || userData?.email || '';
//     const uploaderId = userData?.EmpId || userData?.empId || userData?.id || '';
//     const uploaderRole = userData?.role || (isManagement ? 'Management' : 'Employee');

//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('emp_id', targetEmpId);
//     formData.append('emp_name', empData?.emp_name || `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim());
//     formData.append('doc_type', docType);
//     formData.append('uploaded_by', uploaderName);
//     formData.append('uploaded_by_name', uploaderName);
//     formData.append('uploaded_by_email', uploaderEmail);
//     formData.append('uploaded_by_id', uploaderId);
//     formData.append('uploaded_by_role', uploaderRole);

//     try {
//       const res = await fetch(`${DOCS_API_BASE}/upload_employee_document.php`, {
//         method: "POST",
//         body: formData,
//       });

//       const result = await res.json();
//       if (result.success) {
//         setActionMessage({ type: 'success', text: `✅ "${docType}" successfully uploaded by ${uploaderName}!` });
//         // Refresh documents and management list
//         fetchEmployeeDocuments(targetEmpId);
//         if (isManagement) {
//           fetchAllEmployees();
//         }
//       } else {
//         setActionMessage({ type: 'error', text: `❌ Upload Failed: ${result.message}` });
//       }
//     } catch (err) {
//       console.error("Upload error:", err);
//       setActionMessage({ type: 'error', text: 'Server connection error during upload.' });
//     } finally {
//       setUploadingDocType(null);
//       setTimeout(() => setActionMessage(null), 5000);
//     }
//   };

//   // 4b. HANDLE TICKMARK / MANUAL VERIFICATION TOGGLE (MANAGEMENT ONLY)
//   const handleToggleDocSubmission = async (docType, currentIsSubmitted) => {
//     if (!isManagement || !targetEmpId || togglingDocType) return;

//     const nextAction = currentIsSubmitted ? 'unsubmit' : 'submit';

//     if (currentIsSubmitted) {
//       const confirmRevert = window.confirm(
//         `Are you sure you want to mark "${docType}" as PENDING?`
//       );
//       if (!confirmRevert) return;
//     }

//     setTogglingDocType(docType);
//     const uploaderName = `${userData?.FirstName || 'Management'} ${userData?.LastName || ''}`.trim() || 'HR Management';
//     const uploaderEmail = userData?.EmailId || userData?.email || '';
//     const uploaderId = userData?.EmpId || userData?.empId || userData?.id || '';
//     const uploaderRole = userData?.role || 'Management';

//     try {
//       const res = await fetch(`${DOCS_API_BASE}/toggle_doc_submission.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           emp_id: targetEmpId,
//           doc_type: docType,
//           action: nextAction,
//           manager_name: uploaderName,
//           uploaded_by_name: uploaderName,
//           uploaded_by_email: uploaderEmail,
//           uploaded_by_id: uploaderId,
//           uploaded_by_role: uploaderRole
//         })
//       });

//       const result = await res.json();
//       if (result.success) {
//         setActionMessage({
//           type: 'success',
//           text: nextAction === 'submit'
//             ? `✅ "${docType}" marked as Submitted by ${uploaderName}!`
//             : `ℹ️ "${docType}" reverted to Pending.`
//         });
//         fetchEmployeeDocuments(targetEmpId);
//         fetchAllEmployees();
//       } else {
//         setActionMessage({ type: 'error', text: `❌ ${result.message}` });
//       }
//     } catch (err) {
//       console.error("Error toggling doc submission:", err);
//       setActionMessage({ type: 'error', text: "❌ Failed to update document submission status." });
//     } finally {
//       setTogglingDocType(null);
//       setTimeout(() => setActionMessage(null), 4000);
//     }
//   };

//   // 5. TOGGLE EMPLOYEE ACCESS LOCK / UNLOCK (MANAGEMENT ONLY)
//   const handleToggleLock = async () => {
//     if (!isManagement || !empData) return;

//     const action = empData.is_locked ? 'unlock' : 'lock';
//     const managerName = `${userData?.FirstName || 'Management'} ${userData?.LastName || ''}`.trim();

//     try {
//       const res = await fetch(`${DOCS_API_BASE}/toggle_employee_doc_lock.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           emp_id: targetEmpId,
//           action: action,
//           manager_name: managerName
//         })
//       });

//       const result = await res.json();
//       if (result.success) {
//         setActionMessage({ type: 'success', text: `🔓 ${result.message}` });
//         fetchEmployeeDocuments(targetEmpId);
//         fetchAllEmployees();
//       } else {
//         setActionMessage({ type: 'error', text: `❌ Error: ${result.message}` });
//       }
//     } catch (err) {
//       console.error("Error toggling lock:", err);
//     } finally {
//       setTimeout(() => setActionMessage(null), 5000);
//     }
//   };

//   // 6. SEND REMINDER EMAIL (MANAGEMENT ONLY)
//   const handleSendReminder = async () => {
//     if (!isManagement || !empData || sendingReminder) return;

//     setSendingReminder(true);
//     setReminderSuccess(false);
//     const initialMsg = `Sending reminder email to ${empData.emp_name}...`;
//     setReminderFeedback({ type: 'loading', text: initialMsg });
//     setActionMessage({ type: 'info', text: `⏳ ${initialMsg}` });

//     try {
//       const res = await fetch(`${DOCS_API_BASE}/send_doc_reminder_email.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ emp_id: targetEmpId })
//       });

//       const result = await res.json();
//       if (result.success) {
//         setReminderSuccess(true);
//         const successMsg = result.message || `Reminder email sent successfully to ${empData.emp_name}!`;
//         setReminderFeedback({ type: 'success', text: successMsg });
//         setActionMessage({ type: 'success', text: `✉️ ${successMsg}` });
//         fetchEmployeeDocuments(targetEmpId);
//         fetchAllEmployees();
//         setTimeout(() => setReminderSuccess(false), 5000);
//       } else {
//         const errorMsg = result.message || 'Failed to send reminder email.';
//         setReminderFeedback({ type: 'error', text: errorMsg });
//         setActionMessage({ type: 'error', text: `❌ ${errorMsg}` });
//       }
//     } catch (err) {
//       console.error("Error sending reminder email:", err);
//       const connErrMsg = 'Error connecting to email service.';
//       setReminderFeedback({ type: 'error', text: connErrMsg });
//       setActionMessage({ type: 'error', text: `❌ ${connErrMsg}` });
//     } finally {
//       setSendingReminder(false);
//       setTimeout(() => setReminderFeedback(null), 8000);
//       setTimeout(() => setActionMessage(null), 8000);
//     }
//   };

//   // 7. SEND BULK REMINDER TO ALL EXISTING EMPLOYEES WITH PENDING DOCUMENTS
//   const handleBulkReminder = async () => {
//     if (!isManagement || bulkSending) return;

//     const confirmSend = window.confirm(
//       "Are you sure you want to send official reminder emails to ALL existing employees who have pending documents?\n\nEach employee will receive an email listing their specific pending documents and submission deadline."
//     );
//     if (!confirmSend) return;

//     setBulkSending(true);
//     setBulkSuccess(false);
//     const initialBulkMsg = 'Sending document reminder emails to existing employees...';
//     setBulkFeedback({ type: 'loading', text: initialBulkMsg });
//     setActionMessage({ type: 'info', text: `⏳ ${initialBulkMsg}` });

//     try {
//       const res = await fetch(`${DOCS_API_BASE}/send_bulk_existing_reminders.php`);
//       const result = await res.json();

//       if (result.success) {
//         setBulkSuccess(true);
//         const successMsg = result.message || 'Bulk reminder emails sent successfully!';
//         setBulkFeedback({ type: 'success', text: successMsg });
//         setActionMessage({ type: 'success', text: `✅ ${successMsg}` });
//         fetchAllEmployees();
//         if (targetEmpId) {
//           fetchEmployeeDocuments(targetEmpId);
//         }
//         setTimeout(() => setBulkSuccess(false), 5000);
//       } else {
//         const errorMsg = result.message || 'Failed to send bulk reminder emails.';
//         setBulkFeedback({ type: 'error', text: errorMsg });
//         setActionMessage({ type: 'error', text: `❌ ${errorMsg}` });
//       }
//     } catch (err) {
//       console.error("Bulk reminder error:", err);
//       const connErrMsg = 'Server error while sending bulk reminder emails.';
//       setBulkFeedback({ type: 'error', text: connErrMsg });
//       setActionMessage({ type: 'error', text: `❌ ${connErrMsg}` });
//     } finally {
//       setBulkSending(false);
//       setTimeout(() => setBulkFeedback(null), 9000);
//       setTimeout(() => setActionMessage(null), 9000);
//     }
//   };

//   // Filtered employees list for Management dropdown/search
//   const filteredEmployees = useMemo(() => {
//     if (!searchQuery.trim()) return employeesList;
//     const q = searchQuery.toLowerCase();
//     return employeesList.filter(e =>
//       e.emp_name?.toLowerCase().includes(q) ||
//       e.emp_id?.toString().toLowerCase().includes(q) ||
//       e.department?.toLowerCase().includes(q)
//     );
//   }, [employeesList, searchQuery]);

//   // Available departments list (matching RnU module reference)
//   const availableDepartments = useMemo(() => {
//     const depts = new Set();
//     employeesList.forEach(e => {
//       if (e.department && String(e.department).trim()) {
//         depts.add(String(e.department).trim());
//       }
//     });
//     return ["All", ...Array.from(depts).sort((a, b) => a.localeCompare(b))];
//   }, [employeesList]);

//   // Matrix employees filtered by selected department
//   const matrixDeptEmployees = useMemo(() => {
//     if (!departmentFilter || departmentFilter === 'All') return employeesList;
//     return employeesList.filter(e => (e.department || '').trim().toLowerCase() === departmentFilter.trim().toLowerCase());
//   }, [employeesList, departmentFilter]);

//   // Filtered employees list for Page 1 Compliance Matrix
//   const filteredMatrixEmployees = useMemo(() => {
//     let list = matrixDeptEmployees;

//     // Filter tab
//     if (matrixFilter === 'pending') {
//       list = list.filter(e => Number(e.missing_count) > 0);
//     } else if (matrixFilter === 'compliant') {
//       list = list.filter(e => Number(e.missing_count) === 0);
//     } else if (matrixFilter === 'overdue') {
//       list = list.filter(e => e.is_overdue || e.is_locked);
//     }

//     // Search query
//     if (matrixSearch.trim()) {
//       const q = matrixSearch.toLowerCase();
//       list = list.filter(e =>
//         e.emp_name?.toLowerCase().includes(q) ||
//         e.emp_id?.toString().toLowerCase().includes(q) ||
//         e.department?.toLowerCase().includes(q)
//       );
//     }

//     return list;
//   }, [matrixDeptEmployees, matrixFilter, matrixSearch]);

//   // Currently selected employee object
//   const selectedEmployeeObj = useMemo(() => {
//     return employeesList.find(e => String(e.emp_id) === String(selectedEmpId)) || null;
//   }, [employeesList, selectedEmpId]);

//   // Close custom dropdown on outside click
//   useEffect(() => {
//     const handleOutsideClick = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setIsDropdownOpen(false);
//         setSearchQuery('');
//       }
//     };
//     document.addEventListener('mousedown', handleOutsideClick);
//     return () => document.removeEventListener('mousedown', handleOutsideClick);
//   }, []);

//   // Management Stats Calculations (Overall)
//   const stats = useMemo(() => {
//     const total = employeesList.length;
//     const compliant = employeesList.filter(e => e.missing_count === 0).length;
//     const incomplete = employeesList.filter(e => e.missing_count > 0).length;
//     const overdue = employeesList.filter(e => e.is_overdue || e.is_locked).length;
//     return { total, compliant, incomplete, overdue };
//   }, [employeesList]);

//   // Matrix Toolbar Filter Pill Counts (Dynamic based on selected department)
//   const matrixStats = useMemo(() => {
//     const total = matrixDeptEmployees.length;
//     const compliant = matrixDeptEmployees.filter(e => Number(e.missing_count) === 0).length;
//     const incomplete = matrixDeptEmployees.filter(e => Number(e.missing_count) > 0).length;
//     const overdue = matrixDeptEmployees.filter(e => e.is_overdue || e.is_locked).length;
//     return { total, compliant, incomplete, overdue };
//   }, [matrixDeptEmployees]);

//   const completionPercent = empData ? Math.round((empData.submitted_count / empData.total_required) * 100) : 0;

//   // Format date and time (e.g. "15 Oct 2026, 11:30 PM")
//   const formatDueDateTime = (dateStr) => {
//     if (!dateStr) return '';
//     const cleanStr = String(dateStr).trim().replace(' ', 'T');
//     const d = new Date(cleanStr);
//     if (isNaN(d.getTime())) return dateStr;
//     const hasTime = dateStr.includes(':') || cleanStr.includes('T');
//     return d.toLocaleDateString('en-GB', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       ...(hasTime ? { hour: '2-digit', minute: '2-digit', hour12: true } : {})
//     });
//   };

//   return (
//     <div className={`documents-container ${isLightMode ? 'light-theme light-mode' : 'dark-theme'} animate-fade`}>
//       <div className="docs-hub-card">

//         {/* --- HEADER --- */}
//         <div className="docs-header">
//           <div className="docs-header-left">
//             <div className="docs-icon-badge">📁</div>
//             <div>
//               <h2 className="docs-title">
//                 {isManagement
//                   ? (viewMode === 'matrix' ? "EMPLOYEE_COMPLIANCE_MATRIX" : "EMPLOYEE_DOCUMENT_HUB")
//                   : "MANDATORY_DOCUMENT_VAULT"}
//               </h2>
//               <div className="docs-subtitle">
//                 {isManagement
//                   ? (viewMode === 'matrix'
//                     ? "Real-time compliance checklist of all employees across all 10 mandatory onboarding documents"
//                     : "Track mandatory employee onboarding documentation, review submissions, and manage system access")
//                   : "Submit required company onboarding documents to maintain active dashboard access"}
//               </div>
//             </div>
//           </div>

//           {actionMessage && (
//             <div className={`docs-toast-alert ${actionMessage.type}`}>
//               {actionMessage.text}
//             </div>
//           )}
//         </div>

//         {/* FLOATING TOAST NOTIFICATION (ALWAYS VISIBLE REGARDLESS OF SCROLL) */}
//         {actionMessage && (
//           <div className={`docs-floating-toast ${actionMessage.type} animate-slide-down`}>
//             <span className="toast-icon">
//               {actionMessage.type === 'success' ? '✅' : actionMessage.type === 'error' ? '❌' : '⏳'}
//             </span>
//             <span className="toast-text">{actionMessage.text}</span>
//             <button
//               type="button"
//               className="toast-close-btn"
//               onClick={() => setActionMessage(null)}
//               aria-label="Close message"
//             >
//               ✕
//             </button>
//           </div>
//         )}

//         {/* --- MANAGEMENT VIEW SWITCHER BAR (PAGE 1 vs PAGE 2 TABS) --- */}
//         {isManagement && (
//           <div className="docs-view-switcher-bar">
//             <div className="docs-view-tabs">
//               <button
//                 type="button"
//                 className={`docs-view-tab ${viewMode === 'matrix' ? 'active' : ''}`}
//                 onClick={() => setViewMode('matrix')}
//               >
//                 <span className="tab-icon">📊</span>
//                 <span className="tab-title">ALL EMPLOYEES MATRIX</span>
//                 <span className="tab-badge">{employeesList.length}</span>
//               </button>

//               <button
//                 type="button"
//                 className={`docs-view-tab ${viewMode === 'detail' ? 'active' : ''}`}
//                 onClick={() => setViewMode('detail')}
//               >
//                 <span className="tab-icon">👤</span>
//                 <span className="tab-title">INDIVIDUAL WORKSPACE</span>
//                 {selectedEmployeeObj ? (
//                   <span className="tab-subtext">— {selectedEmployeeObj.emp_name}</span>
//                 ) : (
//                   <span className="tab-subtext">— (Select Employee)</span>
//                 )}
//               </button>
//             </div>

//             {viewMode === 'detail' && (
//               <button
//                 type="button"
//                 className="btn-back-matrix"
//                 onClick={handleBackToMatrix}
//                 title="Return to compliance matrix overview"
//               >
//                 <span className="btn-back-icon">←</span>
//                 <span>Back to All Employees Matrix</span>
//               </button>
//             )}
//           </div>
//         )}

//         {/* ========================================================
//             PAGE 1: ALL EMPLOYEES COMPLIANCE MATRIX (MANAGEMENT)
//             (Compact Single-Page Layout - Zero Horizontal Scroll)
//             ======================================================== */}
//         {isManagement && viewMode === 'matrix' && (
//           <div className="matrix-page-view compact-page-view animate-fade">
//             {/* COMPACT TOOLBAR (SEARCH + DEPT FILTER - RIGHT ALIGNED) */}
//             <div className="matrix-toolbar-compact">
//               <div className="matrix-toolbar-right">
//                 <div className="matrix-search-box-compact">
//                   <span className="matrix-search-icon">🔍</span>
//                   <input
//                     type="text"
//                     className="matrix-search-input-compact"
//                     placeholder="Search by name, ID or department..."
//                     value={matrixSearch}
//                     onChange={(e) => setMatrixSearch(e.target.value)}
//                   />
//                   {matrixSearch && (
//                     <button
//                       type="button"
//                       className="matrix-search-clear"
//                       onClick={() => setMatrixSearch('')}
//                       title="Clear search"
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>

//                 {/* DEPARTMENT FILTER (POLICY RNU REFERENCE) */}
//                 <div className="matrix-dept-filter-wrap">
//                   <select
//                     value={departmentFilter}
//                     onChange={(e) => setDepartmentFilter(e.target.value)}
//                     className="matrix-dept-select"
//                     title="Filter employees by department"
//                   >
//                     {availableDepartments.map((dept, index) => (
//                       <option key={index} value={dept}>
//                         {dept === 'All' ? 'All Departments' : dept}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               {/* <div className="matrix-filters-compact">
//                 <button
//                   type="button"
//                   className={`matrix-filter-pill-compact ${matrixFilter === 'all' ? 'active' : ''}`}
//                   onClick={() => setMatrixFilter('all')}
//                 >
//                   All ({matrixStats.total})
//                 </button>
//                 <button
//                   type="button"
//                   className={`matrix-filter-pill-compact pending ${matrixFilter === 'pending' ? 'active' : ''}`}
//                   onClick={() => setMatrixFilter('pending')}
//                 >
//                   Pending ({matrixStats.incomplete})
//                 </button>
//                 <button
//                   type="button"
//                   className={`matrix-filter-pill-compact compliant ${matrixFilter === 'compliant' ? 'active' : ''}`}
//                   onClick={() => setMatrixFilter('compliant')}
//                 >
//                   Compliant ({matrixStats.compliant})
//                 </button>
//                 <button
//                   type="button"
//                   className={`matrix-filter-pill-compact overdue ${matrixFilter === 'overdue' ? 'active' : ''}`}
//                   onClick={() => setMatrixFilter('overdue')}
//                 >
//                   Restricted ({matrixStats.overdue})
//                 </button>
//                 <button
//                   type="button"
//                   className="matrix-btn-refresh-compact"
//                   onClick={fetchAllEmployees}
//                   title="Reload employee matrix"
//                   disabled={mgmtLoading}
//                 >
//                   {mgmtLoading ? "⏳" : "🔄 Refresh"}
//                 </button>
//               </div> */}
//             </div>

//             {/* 10-DOCUMENT COMPLIANCE MATRIX TABLE (100% WIDTH FIT, ZERO SCROLL) */}
//             <div className="doc-matrix-table-card compact-matrix-card">
//               <div className="doc-matrix-table-wrap compact-matrix-wrap">
//                 <table className="doc-matrix-table compact-matrix-table">
//                   <colgroup>
//                     <col style={{ width: '17%' }} />
//                     {MATRIX_COLUMNS.map(col => (
//                       <col key={col.slot} style={{ width: '7.3%' }} />
//                     ))}
//                     <col style={{ width: '10%' }} />
//                   </colgroup>
//                   <thead>
//                     <tr>
//                       <th className="matrix-th-emp compact-th">EMPLOYEE NAME</th>
//                       {MATRIX_COLUMNS.map((col) => (
//                         <th
//                           key={col.slot}
//                           className="matrix-th-doc compact-th"
//                           style={{ textAlign: 'center', verticalAlign: 'middle' }}
//                           title={col.docType}
//                         >
//                           <div className="compact-header-label" style={{ textAlign: 'center', margin: '0 auto', width: '100%' }}>
//                             {col.label}
//                           </div>
//                         </th>
//                       ))}
//                       <th className="matrix-th-action compact-th" style={{ textAlign: 'center', verticalAlign: 'middle' }}>ACTION</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {mgmtLoading && employeesList.length === 0 ? (
//                       <tr>
//                         <td colSpan={MATRIX_COLUMNS.length + 2} className="doc-loading-cell compact-td">
//                           <span className="doc-inline-spinner" aria-hidden="true"></span>
//                           <span style={{ marginLeft: '8px' }}>Loading employee compliance matrix...</span>
//                         </td>
//                       </tr>
//                     ) : filteredMatrixEmployees.length === 0 ? (
//                       <tr>
//                         <td colSpan={MATRIX_COLUMNS.length + 2} className="doc-empty-prompt-cell compact-td">
//                           {employeesList.length === 0
//                             ? "No employees found in tblemployees."
//                             : `No employees found matching filter "${matrixFilter}"${departmentFilter !== 'All' ? ` in department "${departmentFilter}"` : ''}${matrixSearch ? ` and query "${matrixSearch}"` : ''}.`}
//                         </td>
//                       </tr>
//                     ) : (
//                       filteredMatrixEmployees.map((emp) => {
//                         const isLocked = Boolean(emp.is_locked);
//                         const isCompliant = emp.missing_count === 0;

//                         return (
//                           <tr
//                             key={emp.emp_id}
//                             className={`matrix-row compact-row ${isLocked ? 'row-locked' : ''} ${isCompliant ? 'row-compliant' : ''}`}
//                             onClick={() => handleOpenEmployeeDetail(emp.emp_id)}
//                             title={`Click to open workspace for ${emp.emp_name}`}
//                           >
//                             {/* Column 1: EMPLOYEE NAME */}
//                             <td className="matrix-td-emp compact-td">
//                               <div className="matrix-emp-cell-compact">
//                                 <div className="matrix-emp-avatar-compact">
//                                   {emp.emp_name ? emp.emp_name.charAt(0).toUpperCase() : 'E'}
//                                 </div>
//                                 <div className="matrix-emp-info-compact">
//                                   <div className="matrix-emp-name-compact" title={emp.emp_name}>
//                                     <span>{emp.emp_name}</span>
//                                     {isLocked && <span className="matrix-locked-pill-compact">LOCKED</span>}
//                                   </div>
//                                   <div className="matrix-emp-dept-compact" title={emp.department || 'General'}>
//                                     {emp.department || 'General'}
//                                   </div>
//                                 </div>
//                               </div>
//                             </td>

//                             {/* Columns 2-11: 10 MANDATORY DOCUMENT STATUS BADGES */}
//                             {MATRIX_COLUMNS.map((col) => {
//                               const doc = (emp.documents || []).find(
//                                 d => d.slot_number === col.slot || d.doc_type === col.docType
//                               );
//                               const isSubmitted = Boolean(doc && (doc.is_submitted || doc.status === 'Submitted'));

//                               return (
//                                 <td
//                                   key={col.slot}
//                                   className="matrix-td-status compact-td"
//                                   style={{ textAlign: 'center', verticalAlign: 'middle' }}
//                                   title={`${emp.emp_name} • ${col.label}\nStatus: ${isSubmitted ? 'SUBMITTED' : 'PENDING'}${doc?.file_name ? `\nFile: ${doc.file_name}` : ''}${doc?.uploaded_by ? `\nUploaded By: ${doc.uploaded_by}` : ''}`}
//                                 >
//                                   {isSubmitted ? (
//                                     <div className="matrix-badge-compact matrix-badge-submitted" aria-label="Submitted">
//                                       ✓
//                                     </div>
//                                   ) : (
//                                     <div className="matrix-badge-compact matrix-badge-pending" aria-label="Pending">
//                                       ✕
//                                     </div>
//                                   )}
//                                 </td>
//                               );
//                             })}

//                             {/* Column 12: PROGRESS & ACTION BUTTON */}
//                             <td className="matrix-td-action compact-td" style={{ textAlign: 'center', verticalAlign: 'middle' }} onClick={(e) => e.stopPropagation()}>
//                               <div className="matrix-action-cell-compact">
//                                 <span className={`matrix-count-badge-compact ${isCompliant ? 'full' : 'pending'}`}>
//                                   {emp.submitted_count}/10
//                                 </span>
//                                 <button
//                                   type="button"
//                                   className="btn-matrix-open-compact"
//                                   onClick={() => handleOpenEmployeeDetail(emp.emp_id)}
//                                   title={`Open ${emp.emp_name}'s document workspace`}
//                                 >
//                                   <span className="btn-matrix-text">Manage</span>
//                                   <span className="btn-matrix-arrow">→</span>
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ========================================================
//             PAGE 2: INDIVIDUAL EMPLOYEE WORKSPACE
//             (Shown when regular employee OR when viewMode === 'detail')
//             ======================================================== */}
//         {(!isManagement || viewMode === 'detail') && (
//           <div className="detail-page-view animate-fade">

//             {/* MANAGEMENT SECTION: STATS & EMPLOYEE SELECTOR */}
//             {isManagement && (
//               <>
//                 {/* KPI STATS CARDS */}
//                 <div className="docs-stats-grid">
//                   <div className="docs-stat-card">
//                     <div className="docs-stat-label">Total Monitored</div>
//                     <div className="docs-stat-value">{stats.total}</div>
//                   </div>
//                   <div className="docs-stat-card compliant">
//                     <div className="docs-stat-label">Fully Compliant (10/10)</div>
//                     <div className="docs-stat-value">{stats.compliant}</div>
//                   </div>
//                   <div className="docs-stat-card pending">
//                     <div className="docs-stat-label">Pending Submissions</div>
//                     <div className="docs-stat-value">{stats.incomplete}</div>
//                   </div>
//                   <div className="docs-stat-card overdue">
//                     <div className="docs-stat-label">Overdue / Restricted</div>
//                     <div className="docs-stat-value">{stats.overdue}</div>
//                   </div>
//                 </div>

//                 {/* 📢 BULK ACTION BAR FOR EXISTING EMPLOYEES */}
//                 <div className="bulk-reminder-card">
//                   <div>
//                     <div className="bulk-reminder-title">
//                       <span>📢</span> NOTIFY ALL EXISTING EMPLOYEES WITH PENDING DOCUMENTS
//                     </div>
//                     <div className="bulk-reminder-desc">
//                       Click this button to trigger an official reminder email to all existing employees who have not yet submitted all 10 mandatory documents.
//                     </div>
//                   </div>

//                   <div className="bulk-btn-wrapper">
//                     <button
//                       type="button"
//                       className={`btn-bulk-reminder ${bulkSending ? 'is-loading' : ''} ${bulkSuccess ? 'is-success' : ''}`}
//                       disabled={bulkSending || stats.incomplete === 0}
//                       onClick={handleBulkReminder}
//                     >
//                       {bulkSending ? (
//                         <>
//                           <span className="doc-btn-spinner" aria-hidden="true"></span>
//                           <span>Sending Emails...</span>
//                         </>
//                       ) : bulkSuccess ? (
//                         <>
//                           <span>✅</span>
//                           <span>Emails Sent Successfully!</span>
//                         </>
//                       ) : (
//                         <span>✉️ Send Email to All Existing Employees ({stats.incomplete} Pending)</span>
//                       )}
//                     </button>

//                     {bulkFeedback && (
//                       <div className={`bulk-action-feedback ${bulkFeedback.type} animate-fade`}>
//                         {bulkFeedback.type === 'loading' && <span className="doc-inline-spinner" aria-hidden="true"></span>}
//                         {bulkFeedback.type === 'success' && <span className="feedback-icon">✅</span>}
//                         {bulkFeedback.type === 'error' && <span className="feedback-icon">❌</span>}
//                         <span className="feedback-text">{bulkFeedback.text}</span>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* EMPLOYEE SELECTOR */}
//                 <div className={`emp-selector-panel ${isDropdownOpen ? 'dropdown-active' : ''}`} style={{ position: 'relative', zIndex: isDropdownOpen ? 10000 : 1 }}>
//                   <label className="emp-selector-label">
//                     SELECT EMPLOYEE TO MANAGE DOCUMENTS
//                   </label>
//                   <div className="emp-selector-row" style={{ marginTop: '10px' }}>
//                     <div className="emp-select-box" ref={dropdownRef} style={{ flex: '1', position: 'relative', zIndex: isDropdownOpen ? 10001 : 1 }}>
//                       {/* SINGLE UNIFIED SEARCHABLE DROPDOWN FIELD (NO TWO FIELDS) */}
//                       <div
//                         className={`emp-combobox-field ${isDropdownOpen ? 'open' : ''}`}
//                         onClick={() => {
//                           if (!isDropdownOpen) {
//                             setIsDropdownOpen(true);
//                           }
//                           searchInputRef.current?.focus();
//                         }}
//                         role="combobox"
//                         aria-expanded={isDropdownOpen}
//                       >
//                         <span className="emp-combobox-icon">🔍</span>

//                         <input
//                           ref={searchInputRef}
//                           type="text"
//                           className="emp-combobox-input"
//                           value={isDropdownOpen ? searchQuery : (selectedEmployeeObj ? `${selectedEmployeeObj.emp_name} (${selectedEmployeeObj.emp_id}) — ${selectedEmployeeObj.department || 'General'}` : '')}
//                           placeholder={
//                             isDropdownOpen
//                               ? (selectedEmployeeObj ? `Type to search (Current: ${selectedEmployeeObj.emp_name})...` : "Type to filter by name, ID or department...")
//                               : "Select employee to manage documents..."
//                           }
//                           onChange={(e) => {
//                             setSearchQuery(e.target.value);
//                             if (!isDropdownOpen) setIsDropdownOpen(true);
//                           }}
//                           onFocus={() => {
//                             setIsDropdownOpen(true);
//                           }}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setIsDropdownOpen(true);
//                           }}
//                         />

//                         {/* Meta info tags when closed or not searching */}
//                         {selectedEmployeeObj && !searchQuery && (
//                           <div className="emp-combobox-meta">
//                             <span className="emp-count-pill">[{selectedEmployeeObj.submitted_count}/10 Docs]</span>
//                             {selectedEmployeeObj.is_locked && <span className="emp-lock-warning">⚠️ LOCKED</span>}
//                           </div>
//                         )}

//                         {/* Clear search button if typed */}
//                         {searchQuery && (
//                           <button
//                             type="button"
//                             className="emp-combobox-clear-btn"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setSearchQuery('');
//                               searchInputRef.current?.focus();
//                             }}
//                             title="Clear filter"
//                           >
//                             ✕
//                           </button>
//                         )}

//                         {/* Dropdown chevron toggle */}
//                         <span
//                           className={`emp-arrow ${isDropdownOpen ? 'rotated' : ''}`}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setIsDropdownOpen(prev => {
//                               const nextState = !prev;
//                               if (nextState) {
//                                 setTimeout(() => searchInputRef.current?.focus(), 50);
//                               } else {
//                                 setSearchQuery('');
//                               }
//                               return nextState;
//                             });
//                           }}
//                           role="button"
//                           tabIndex={0}
//                         >
//                           ▼
//                         </span>
//                       </div>

//                       {/* ⬇️ STRICTLY DOWNWARD OPENING DROPDOWN MENU ⬇️ */}
//                       {isDropdownOpen && (
//                         <div className="emp-downward-menu animate-fade">
//                           {filteredEmployees.length === 0 ? (
//                             <div className="emp-option-empty">
//                               No employees found matching "{searchQuery}"
//                             </div>
//                           ) : (
//                             filteredEmployees.map(emp => {
//                               const isSelected = String(emp.emp_id) === String(selectedEmpId);
//                               return (
//                                 <div
//                                   key={emp.emp_id}
//                                   className={`emp-custom-option ${isSelected ? 'active' : ''}`}
//                                   onClick={() => {
//                                     setSelectedEmpId(emp.emp_id);
//                                     setIsDropdownOpen(false);
//                                   }}
//                                 >
//                                   <div className="emp-option-left">
//                                     <div className="emp-opt-avatar">
//                                       {emp.emp_name?.charAt(0) || "E"}
//                                     </div>
//                                     <div className="emp-opt-info">
//                                       <div className="emp-opt-name">
//                                         {emp.emp_name} <span className="emp-opt-id">({emp.emp_id})</span>
//                                       </div>
//                                       <div className="emp-opt-dept">{emp.department || 'General'}</div>
//                                     </div>
//                                   </div>

//                                   <div className="emp-option-right">
//                                     <span className={`emp-opt-badge ${emp.missing_count === 0 ? 'full' : 'pending'}`}>
//                                       {emp.submitted_count}/10 Docs
//                                     </span>
//                                     {emp.is_locked && <span className="emp-opt-locked">⚠️ LOCKED</span>}
//                                     {isSelected && <span className="emp-opt-check">✓</span>}
//                                   </div>
//                                 </div>
//                               );
//                             })
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </>
//             )}

//             {/* ========================================================
//                 ACTIVE EMPLOYEE PROFILE & COMPLIANCE BANNER
//                 ======================================================== */}
//             {empData && (
//               <div className="selected-emp-banner">
//                 <div className="emp-profile-info">
//                   <div className="emp-avatar">
//                     {empData.emp_name?.charAt(0) || "E"}
//                   </div>
//                   <div className="emp-details-text">
//                     <h3>{empData.emp_name}</h3>
//                     <div className="emp-meta-pills">
//                       <span className="pill-tag">ID: {empData.emp_id}</span>
//                       {empData.department && <span className="pill-tag">Dept: {empData.department}</span>}
//                       <span className="pill-tag due">
//                         Due: {formatDueDateTime(empData.due_date)}
//                       </span>

//                       {empData.is_locked ? (
//                         <span className="pill-tag locked">🚫 ACCESS RESTRICTED</span>
//                       ) : empData.manually_unlocked ? (
//                         <span className="pill-tag unlocked">🔓 MANUALLY UNLOCKED</span>
//                       ) : empData.missing_count === 0 ? (
//                         <span className="pill-tag unlocked">✓ FULLY COMPLIANT</span>
//                       ) : (
//                         <span className="pill-tag due">PENDING SUBMISSION</span>
//                       )}

//                       {empData.last_reminder_sent && (
//                         <span className="pill-tag reminder-info" title="Timestamp of last sent reminder email">
//                           ✉️ Last Reminded: {new Date(empData.last_reminder_sent).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
//                         </span>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* MANAGEMENT ACTION CONTROLS */}
//                 {isManagement && (
//                   <div className="emp-actions-wrapper">
//                     <div className="emp-actions-group">
//                       <button
//                         type="button"
//                         className={`btn-lock-toggle ${empData.is_locked ? 'unlock-mode' : 'lock-mode'}`}
//                         onClick={handleToggleLock}
//                       >
//                         {empData.is_locked ? "🔓 Unlock Access" : "🔒 Restrict Access"}
//                       </button>

//                       <button
//                         type="button"
//                         className={`btn-reminder-email ${sendingReminder ? 'is-loading' : ''} ${reminderSuccess ? 'is-success' : ''}`}
//                         onClick={handleSendReminder}
//                         disabled={empData.missing_count === 0 || sendingReminder}
//                       >
//                         {sendingReminder ? (
//                           <>
//                             <span className="doc-btn-spinner" aria-hidden="true"></span>
//                             <span>Sending Email...</span>
//                           </>
//                         ) : reminderSuccess ? (
//                           <>
//                             <span>✅</span>
//                             <span>Email Sent!</span>
//                           </>
//                         ) : (
//                           <>
//                             <span>✉️</span>
//                             <span>Send Reminder Email</span>
//                           </>
//                         )}
//                       </button>
//                     </div>

//                     {/* INLINE STATUS / LOADER FEEDBACK RIGHT AT THE BUTTON */}
//                     {reminderFeedback && (
//                       <div className={`emp-action-feedback ${reminderFeedback.type} animate-fade`}>
//                         {reminderFeedback.type === 'loading' && <span className="doc-inline-spinner" aria-hidden="true"></span>}
//                         {reminderFeedback.type === 'success' && <span className="feedback-icon">✅</span>}
//                         {reminderFeedback.type === 'error' && <span className="feedback-icon">❌</span>}
//                         <span className="feedback-text">{reminderFeedback.text}</span>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             )}

//             {/* ========================================================
//                 COUNTDOWN TIMER BANNER (SHOWN TO BOTH OR EMPLOYEE)
//                 ======================================================== */}
//             {empData && (
//               <div className={`countdown-banner ${empData.is_overdue ? 'overdue-mode' : ''}`}>
//                 <div className="countdown-title-area">
//                   <h3>
//                     {empData.is_overdue
//                       ? "⚠️ DOCUMENT DEADLINE EXPIRED"
//                       : empData.is_existing_employee
//                         ? "📅 EXISTING EMPLOYEE SUBMISSION DEADLINE"
//                         : "⏳ 6-WEEKS ONBOARDING COMPLIANCE WINDOW"}
//                   </h3>
//                   <p>
//                     {empData.is_overdue
//                       ? "Submission deadline was " + formatDueDateTime(empData.due_date) + ". Mandatory documents must be submitted immediately."
//                       : "All 10 mandatory documents must be uploaded before deadline (" + formatDueDateTime(empData.due_date) + ") to maintain dashboard access."}
//                   </p>
//                 </div>

//                 <div className="timer-units-row">
//                   <div className="timer-box">
//                     <div className="timer-val">{String(timeLeft.days).padStart(2, '0')}</div>
//                     <div className="timer-lbl">Days</div>
//                   </div>
//                   <div className="timer-box">
//                     <div className="timer-val">{String(timeLeft.hours).padStart(2, '0')}</div>
//                     <div className="timer-lbl">Hours</div>
//                   </div>
//                   <div className="timer-box">
//                     <div className="timer-val">{String(timeLeft.minutes).padStart(2, '0')}</div>
//                     <div className="timer-lbl">Mins</div>
//                   </div>
//                   <div className="timer-box">
//                     <div className="timer-val">{String(timeLeft.seconds).padStart(2, '0')}</div>
//                     <div className="timer-lbl">Secs</div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* PROGRESS BAR */}
//             {empData && (
//               <div className="compliance-progress-wrap">
//                 <div className="progress-labels">
//                   <span>DOCUMENT SUBMISSION PROGRESS</span>
//                   <span>{empData.submitted_count} of {empData.total_required} Submitted ({completionPercent}%)</span>
//                 </div>
//                 <div className="progress-bar-track">
//                   <div className="progress-bar-fill" style={{ width: `${completionPercent}%` }}></div>
//                 </div>
//               </div>
//             )}

//             {/* ========================================================
//                 10 MANDATORY DOCUMENTS CHECKLIST TABLE
//                 ======================================================== */}
//             <div className="docs-table-container">
//               <table className="docs-custom-table">
//                 <thead>
//                   <tr>
//                     <th className="doc-th-num" style={{ width: '45px', textAlign: 'center' }}>#</th>
//                     <th className="doc-th-type" style={{ width: '25%', minWidth: '200px' }}>REQUIRED DOCUMENT TYPE</th>
//                     <th className="doc-th-status" style={{ width: '155px' }}>STATUS</th>
//                     <th className="doc-th-info" style={{ width: '190px' }}>UPLOADED FILE INFO</th>
//                     <th className="doc-th-action" style={{ textAlign: 'right', minWidth: '380px' }}>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loadingDocs ? (
//                     <tr>
//                       <td colSpan="5" className="doc-loading-cell">
//                         Loading documents...
//                       </td>
//                     </tr>
//                   ) : (!empData && isManagement) ? (
//                     <tr>
//                       <td colSpan="5" className="doc-empty-prompt-cell">
//                         👉 Please select an employee from the dropdown above or switch to the <b>All Employees Matrix</b> tab to pick an employee.
//                       </td>
//                     </tr>
//                   ) : documents.map((doc, idx) => {
//                     const isSubmitted = doc.status === 'Submitted';
//                     const isBusyUploading = uploadingDocType === doc.doc_type;
//                     const isToggling = togglingDocType === doc.doc_type;
//                     const hasPhysicalFile = Boolean(doc.file_path && doc.file_path.trim() !== '');

//                     return (
//                       <tr key={doc.doc_type || idx} className={isSubmitted ? "row-submitted" : "row-pending"}>
//                         {/* Number Badge */}
//                         <td className="doc-td-num">
//                           <div className="doc-num-badge">{idx + 1}</div>
//                         </td>

//                         {/* Document Title */}
//                         <td className="doc-td-type">
//                           <div className="doc-name-cell">
//                             <div>
//                               <div className="doc-name-title">{doc.doc_type}</div>
//                               {isSubmitted && hasPhysicalFile && (
//                                 <div className="doc-file-info">
//                                   📄 {doc.file_name} • {doc.file_size || ''}
//                                 </div>
//                               )}
//                               {isSubmitted && !hasPhysicalFile && (
//                                 <div className="doc-file-info doc-verified-info">
//                                   ✓ Verified without file upload
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </td>

//                         {/* Status Badge & Tickmark */}
//                         <td className="doc-td-status">
//                           {isManagement ? (
//                             <label
//                               className={`mgmt-doc-toggle-wrap ${isSubmitted ? 'is-submitted' : 'is-pending'}`}
//                               title={isSubmitted ? "Click tickmark to revert to Pending" : "Click tickmark to mark as Submitted"}
//                             >
//                               <input
//                                 type="checkbox"
//                                 className="mgmt-doc-checkbox"
//                                 checked={isSubmitted}
//                                 disabled={isToggling || isBusyUploading}
//                                 onChange={() => handleToggleDocSubmission(doc.doc_type, isSubmitted)}
//                               />
//                               <span className="mgmt-doc-custom-check">
//                                 {isToggling ? "⏳" : isSubmitted ? "✓" : ""}
//                               </span>
//                               <span className={`badge-status ${isSubmitted ? 'submitted' : 'pending'}`}>
//                                 {isSubmitted ? "✓ SUBMITTED" : "PENDING"}
//                               </span>
//                             </label>
//                           ) : (
//                             <span className={`badge-status ${isSubmitted ? 'submitted' : 'pending'}`}>
//                               {isSubmitted ? "✓ SUBMITTED" : "PENDING"}
//                             </span>
//                           )}
//                         </td>

//                         {/* File Metadata */}
//                         <td className="doc-td-info">
//                           {isSubmitted ? (
//                             <div className="doc-meta-info">
//                               <div>
//                                 {hasPhysicalFile ? "By: " : "Verified By: "}
//                                 <b>{doc.uploaded_by || 'Management'}</b>
//                               </div>
//                               <div className="doc-meta-date">
//                                 {doc.uploaded_at ? new Date(doc.uploaded_at).toLocaleDateString('en-GB') : ''}
//                                 {!hasPhysicalFile && " • Verified"}
//                               </div>
//                             </div>
//                           ) : (
//                             <span className="doc-awaiting-text">
//                               {isManagement ? "Awaiting upload or tick mark" : "Awaiting file upload"}
//                             </span>
//                           )}
//                         </td>

//                         {/* Actions */}
//                         <td className="doc-td-action" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
//                           <div className="doc-action-btns" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}>
//                             {/* 1. If Submitted */}
//                             {isSubmitted && (
//                               <>
//                                 {hasPhysicalFile && doc.file_url && (
//                                   <a
//                                     href={doc.file_url}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="btn-doc-view"
//                                     title="Preview document in browser"
//                                   >
//                                     👁️ VIEW
//                                   </a>
//                                 )}

//                                 {hasPhysicalFile && (
//                                   <a
//                                     href={doc.download_url || `${DOCS_API_BASE}/download_doc.php?id=${doc.doc_id || ''}&path=${encodeURIComponent(doc.file_path || '')}`}
//                                     className="btn-doc-download"
//                                     title={`Download ${doc.file_name || doc.doc_type}`}
//                                     download={doc.file_name || doc.doc_type}
//                                   >
//                                     ⬇️ DOWNLOAD
//                                   </a>
//                                 )}

//                                 {/* Management can replace file if file exists, or attach file if only ticked */}
//                                 {isManagement && (
//                                   <label className={hasPhysicalFile ? "btn-doc-replace" : "btn-doc-upload"} style={{ cursor: 'pointer' }}>
//                                     {isBusyUploading ? "Uploading..." : (hasPhysicalFile ? "🔄 Replace" : "⬆️ Attach File")}
//                                     <input
//                                       type="file"
//                                       hidden
//                                       accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                                       disabled={isBusyUploading || isToggling}
//                                       onChange={(e) => {
//                                         if (e.target.files[0]) {
//                                           handleFileUpload(doc.doc_type, e.target.files[0]);
//                                           e.target.value = null;
//                                         }
//                                       }}
//                                     />
//                                   </label>
//                                 )}

//                                 {/* Management can unmark/revert to pending */}
//                                 {isManagement && (
//                                   <button
//                                     type="button"
//                                     className="btn-doc-unmark"
//                                     title="Revert to pending"
//                                     disabled={isToggling || isBusyUploading}
//                                     onClick={() => handleToggleDocSubmission(doc.doc_type, true)}
//                                   >
//                                     {isToggling ? "..." : "✕ Unmark"}
//                                   </button>
//                                 )}
//                               </>
//                             )}

//                             {/* 2. If Pending */}
//                             {!isSubmitted && (
//                               <>
//                                 {/* Management Quick Tickmark Button */}
//                                 {isManagement && (
//                                   <button
//                                     type="button"
//                                     className="btn-doc-tick"
//                                     title="Mark this document as submitted without uploading a file"
//                                     disabled={isToggling || isBusyUploading}
//                                     onClick={() => handleToggleDocSubmission(doc.doc_type, false)}
//                                   >
//                                     {isToggling ? (
//                                       <>
//                                         <span className="doc-btn-spinner" aria-hidden="true"></span>
//                                         <span>Saving...</span>
//                                       </>
//                                     ) : (
//                                       <span>✓ Tick Mark</span>
//                                     )}
//                                   </button>
//                                 )}

//                                 {/* Upload file button (available to both management and employee) */}
//                                 <label className="btn-doc-upload">
//                                   {isBusyUploading ? "Uploading..." : (isManagement ? "⬆️ Upload Doc" : "⬆️ Upload File")}
//                                   <input
//                                     type="file"
//                                     hidden
//                                     accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
//                                     disabled={isBusyUploading || isToggling}
//                                     onChange={(e) => {
//                                       if (e.target.files[0]) {
//                                         handleFileUpload(doc.doc_type, e.target.files[0]);
//                                         e.target.value = null;
//                                       }
//                                     }}
//                                   />
//                                 </label>
//                               </>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default Documents;



















import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import '../styles/Documents.css';

const MANDATORY_DOCUMENTS = [
  "Duly signed copy of Offer Letter (Sign and scan all page into single PDF)",
  "Employment Agreement (Sign and scan all page into single PDF)",
  "Academic Qualification",
  "Aadhar Card",
  "Permanent Account Number (PAN)",
  "Passport Size Photograph",
  "Police verification (character certificate)",
  "Salary slip of last 3 months",
  "Bank Account Details",
  "Medical checkup report",
  "Rental agreement/adress proof"
];

// Matrix Columns for Management Page 1 Overview
const MATRIX_COLUMNS = [
  { slot: 1, label: "OFFER LETTER", docType: "Duly signed copy of Offer Letter (Sign and scan all page into single PDF)" },
  { slot: 2, label: "EMPLOYMENT AGREEMENT", docType: "Employment Agreement (Sign and scan all page into single PDF)" },
  { slot: 3, label: "ACADEMIC QUALIF.", docType: "Academic Qualification" },
  { slot: 4, label: "AADHAR CARD", docType: "Aadhar Card" },
  { slot: 5, label: "PAN CARD", docType: "Permanent Account Number (PAN)" },
  { slot: 6, label: "PASSPORT PHOTO", docType: "Passport Size Photograph" },
  { slot: 7, label: "POLICE VERIF.", docType: "Police verification (character certificate)" },
  { slot: 8, label: "SALARY SLIPS", docType: "Salary slip of last 3 months" },
  { slot: 9, label: "BANK DETAILS", docType: "Bank Account Details" },
  { slot: 10, label: "MEDICAL REPORT", docType: "Medical checkup report" },
  { slot: 11, label: "RENTAL / ADDR PROOF", docType: "Rental agreement/adress proof" }
];

// Permanently excluded employees (never show in Documents UI or send emails)
const EXCLUDED_EMAILS = [
  'aaron.fisher@gtecorpgroup.com',
  'aron.fisher@gtecorpgroup.com',
  'sandeep.potti@gtecorpgroup.com'
];
const EXCLUDED_NAMES = [
  'aron fisher',
  'aaron fisher',
  'sandeep potti'
];

const isExcludedEmployee = (emp) => {
  if (!emp) return false;
  const email = (emp.email || emp.EmailId || '').trim().toLowerCase();
  if (email && EXCLUDED_EMAILS.includes(email)) return true;
  const name = (emp.emp_name || emp.name || (emp.FirstName ? `${emp.FirstName} ${emp.LastName || ''}` : '')).trim().toLowerCase().replace(/\s+/g, ' ');
  if (name && EXCLUDED_NAMES.includes(name)) return true;
  return false;
};

// Dynamic API Base: Uses /gt-api on local development and /gt-api on server
const DOCS_API_BASE = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? '/gt-api'
  : '/gt-api';

const Documents = ({ userData }) => {
  const isManagement = userData?.role === 'Management' || userData?.role === 'Admin';
  const currentEmpId = userData?.id || userData?.empId || userData?.EmpId;

  // View mode: 'matrix' (Page 1) or 'detail' (Page 2)
  // Management defaults to 'matrix'; regular employees always see their own 'detail'
  const [viewMode, setViewMode] = useState(isManagement ? 'matrix' : 'detail');
  const [matrixSearch, setMatrixSearch] = useState('');
  const [matrixFilter, setMatrixFilter] = useState('all'); // 'all', 'pending', 'compliant', 'overdue'
  const [departmentFilter, setDepartmentFilter] = useState('All'); // 'All' or specific department (Policy RnU style)

  // Management State
  const [employeesList, setEmployeesList] = useState([]);
  const [selectedEmpId, setSelectedEmpId] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [mgmtLoading, setMgmtLoading] = useState(false);
  const [bulkSending, setBulkSending] = useState(false);
  const [bulkSuccess, setBulkSuccess] = useState(false);
  const [bulkFeedback, setBulkFeedback] = useState(null);
  const [sendingReminder, setSendingReminder] = useState(false);
  const [reminderSuccess, setReminderSuccess] = useState(false);
  const [reminderFeedback, setReminderFeedback] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  // Switch to Page 2 for selected employee
  const handleOpenEmployeeDetail = (empId) => {
    setSelectedEmpId(empId);
    setViewMode('detail');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Return to Page 1 Matrix Overview
  const handleBackToMatrix = () => {
    setViewMode('matrix');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Reset email feedback when selected employee changes
  useEffect(() => {
    setReminderFeedback(null);
    setReminderSuccess(false);
  }, [selectedEmpId]);

  // Active Employee Document Detail State
  const [empData, setEmpData] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [uploadingDocType, setUploadingDocType] = useState(null);
  const [togglingDocType, setTogglingDocType] = useState(null);
  const [actionMessage, setActionMessage] = useState(null);

  // Countdown timer state
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  // Theme observer to detect light vs dark theme
  const [isLightMode, setIsLightMode] = useState(() => {
    return (
      document.body.classList.contains('light-theme') ||
      document.documentElement.classList.contains('light-theme') ||
      document.documentElement.getAttribute('data-theme') === 'light' ||
      localStorage.getItem('dashboard-theme') === 'light'
    );
  });

  useEffect(() => {
    const detectTheme = () => {
      const isLight =
        document.body.classList.contains('light-theme') ||
        document.documentElement.classList.contains('light-theme') ||
        document.documentElement.getAttribute('data-theme') === 'light' ||
        localStorage.getItem('dashboard-theme') === 'light';
      setIsLightMode(isLight);
    };

    detectTheme();

    const observer = new MutationObserver(detectTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme'] });

    window.addEventListener('storage', detectTheme);

    return () => {
      observer.disconnect();
      window.removeEventListener('storage', detectTheme);
    };
  }, []);

  // 1. FETCH ALL EMPLOYEES (FOR MANAGEMENT)
  const fetchAllEmployees = useCallback(async () => {
    if (!isManagement) return;
    setMgmtLoading(true);
    try {
      const res = await fetch(`${DOCS_API_BASE}/get_employee_doc_status.php?all=1`);
      const data = await res.json();
      if (data.success) {
        const cleanList = (data.employees || []).filter(e => !isExcludedEmployee(e));
        setEmployeesList(cleanList);
        // Kept empty by default until user chooses an employee from the dropdown
      }
    } catch (err) {
      console.error("Error fetching employees document list:", err);
    } finally {
      setMgmtLoading(false);
    }
  }, [isManagement]);

  useEffect(() => {
    if (isManagement) {
      fetchAllEmployees();
    }
  }, [fetchAllEmployees, isManagement]);

  // 2. FETCH DOCUMENTS FOR TARGET EMPLOYEE
  const targetEmpId = isManagement ? selectedEmpId : currentEmpId;

  const fetchEmployeeDocuments = useCallback(async (empIdToFetch) => {
    if (!empIdToFetch) {
      setEmpData(null);
      setDocuments([]);
      return;
    }
    setLoadingDocs(true);
    try {
      const res = await fetch(`${DOCS_API_BASE}/get_employee_doc_status.php?emp_id=${encodeURIComponent(empIdToFetch)}`);
      const data = await res.json();
      if (data.success) {
        if (isExcludedEmployee(data.employee)) {
          setEmpData(null);
          setDocuments([]);
          return;
        }
        setEmpData(data.employee);
        setDocuments(data.documents || []);
      }
    } catch (err) {
      console.error("Error fetching employee documents:", err);
    } finally {
      setLoadingDocs(false);
    }
  }, []);

  useEffect(() => {
    if (targetEmpId) {
      fetchEmployeeDocuments(targetEmpId);
    } else {
      setEmpData(null);
      setDocuments([]);
    }
  }, [targetEmpId, fetchEmployeeDocuments]);

  // 3. LIVE COUNTDOWN TIMER TICKER
  useEffect(() => {
    if (!empData?.due_date) return;

    const calculateTimeRemaining = () => {
      let dateString = String(empData.due_date).trim();
      if (dateString.includes(' ')) {
        dateString = dateString.replace(' ', 'T');
      } else if (!dateString.includes('T')) {
        dateString = `${dateString}T23:59:59`;
      }
      const target = new Date(dateString).getTime();
      const now = new Date().getTime();
      const difference = target - now;

      if (difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        setTimeLeft({ days, hours, minutes, seconds });
      }
    };

    calculateTimeRemaining();
    const interval = setInterval(calculateTimeRemaining, 1000);
    return () => clearInterval(interval);
  }, [empData?.due_date]);

  // 4. HANDLE DOCUMENT UPLOAD (MANAGEMENT OR EMPLOYEE)
  const handleFileUpload = async (docType, file) => {
    if (!file) return;

    setUploadingDocType(docType);
    const uploaderName = `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim() || userData?.name || (isManagement ? 'Management' : 'Employee');
    const uploaderEmail = userData?.EmailId || userData?.email || '';
    const uploaderId = userData?.EmpId || userData?.empId || userData?.id || '';
    const uploaderRole = userData?.role || (isManagement ? 'Management' : 'Employee');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('emp_id', targetEmpId);
    formData.append('emp_name', empData?.emp_name || `${userData?.FirstName || ''} ${userData?.LastName || ''}`.trim());
    formData.append('doc_type', docType);
    formData.append('uploaded_by', uploaderName);
    formData.append('uploaded_by_name', uploaderName);
    formData.append('uploaded_by_email', uploaderEmail);
    formData.append('uploaded_by_id', uploaderId);
    formData.append('uploaded_by_role', uploaderRole);

    try {
      const res = await fetch(`${DOCS_API_BASE}/upload_employee_document.php`, {
        method: "POST",
        body: formData,
      });

      const result = await res.json();
      if (result.success) {
        setActionMessage({ type: 'success', text: `✅ "${docType}" successfully uploaded by ${uploaderName}!` });
        // Refresh documents and management list
        fetchEmployeeDocuments(targetEmpId);
        if (isManagement) {
          fetchAllEmployees();
        }
      } else {
        setActionMessage({ type: 'error', text: `❌ Upload Failed: ${result.message}` });
      }
    } catch (err) {
      console.error("Upload error:", err);
      setActionMessage({ type: 'error', text: 'Server connection error during upload.' });
    } finally {
      setUploadingDocType(null);
      setTimeout(() => setActionMessage(null), 5000);
    }
  };

  // 4b. HANDLE TICKMARK / MANUAL VERIFICATION TOGGLE (MANAGEMENT ONLY)
  const handleToggleDocSubmission = async (docType, currentIsSubmitted) => {
    if (!isManagement || !targetEmpId || togglingDocType) return;

    const nextAction = currentIsSubmitted ? 'unsubmit' : 'submit';

    if (currentIsSubmitted) {
      const confirmRevert = window.confirm(
        `Are you sure you want to mark "${docType}" as PENDING?`
      );
      if (!confirmRevert) return;
    }

    setTogglingDocType(docType);
    const uploaderName = `${userData?.FirstName || 'Management'} ${userData?.LastName || ''}`.trim() || 'HR Management';
    const uploaderEmail = userData?.EmailId || userData?.email || '';
    const uploaderId = userData?.EmpId || userData?.empId || userData?.id || '';
    const uploaderRole = userData?.role || 'Management';

    try {
      const res = await fetch(`${DOCS_API_BASE}/toggle_doc_submission.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          emp_id: targetEmpId,
          doc_type: docType,
          action: nextAction,
          manager_name: uploaderName,
          uploaded_by_name: uploaderName,
          uploaded_by_email: uploaderEmail,
          uploaded_by_id: uploaderId,
          uploaded_by_role: uploaderRole
        })
      });

      const result = await res.json();
      if (result.success) {
        setActionMessage({
          type: 'success',
          text: nextAction === 'submit'
            ? `✅ "${docType}" marked as Submitted by ${uploaderName}!`
            : `ℹ️ "${docType}" reverted to Pending.`
        });
        fetchEmployeeDocuments(targetEmpId);
        fetchAllEmployees();
      } else {
        setActionMessage({ type: 'error', text: `❌ ${result.message}` });
      }
    } catch (err) {
      console.error("Error toggling doc submission:", err);
      setActionMessage({ type: 'error', text: "❌ Failed to update document submission status." });
    } finally {
      setTogglingDocType(null);
      setTimeout(() => setActionMessage(null), 4000);
    }
  };

  // 5. TOGGLE EMPLOYEE ACCESS LOCK / UNLOCK (MANAGEMENT ONLY)
  const handleToggleLock = async () => {
    if (!isManagement || !empData) return;

    const action = empData.is_locked ? 'unlock' : 'lock';
    const managerName = `${userData?.FirstName || 'Management'} ${userData?.LastName || ''}`.trim();

    try {
      const res = await fetch(`${DOCS_API_BASE}/toggle_employee_doc_lock.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          emp_id: targetEmpId,
          action: action,
          manager_name: managerName
        })
      });

      const result = await res.json();
      if (result.success) {
        setActionMessage({ type: 'success', text: `🔓 ${result.message}` });
        fetchEmployeeDocuments(targetEmpId);
        fetchAllEmployees();
      } else {
        setActionMessage({ type: 'error', text: `❌ Error: ${result.message}` });
      }
    } catch (err) {
      console.error("Error toggling lock:", err);
    } finally {
      setTimeout(() => setActionMessage(null), 5000);
    }
  };

  // 6. SEND REMINDER EMAIL (MANAGEMENT ONLY)
  const handleSendReminder = async () => {
    if (!isManagement || !empData || sendingReminder) return;

    setSendingReminder(true);
    setReminderSuccess(false);
    const initialMsg = `Sending reminder email to ${empData.emp_name}...`;
    setReminderFeedback({ type: 'loading', text: initialMsg });
    setActionMessage({ type: 'info', text: `⏳ ${initialMsg}` });

    try {
      const res = await fetch(`${DOCS_API_BASE}/send_doc_reminder_email.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ emp_id: targetEmpId })
      });

      const result = await res.json();
      if (result.success) {
        setReminderSuccess(true);
        const successMsg = result.message || `Reminder email sent successfully to ${empData.emp_name}!`;
        setReminderFeedback({ type: 'success', text: successMsg });
        setActionMessage({ type: 'success', text: `✉️ ${successMsg}` });
        fetchEmployeeDocuments(targetEmpId);
        fetchAllEmployees();
        setTimeout(() => setReminderSuccess(false), 5000);
      } else {
        const errorMsg = result.message || 'Failed to send reminder email.';
        setReminderFeedback({ type: 'error', text: errorMsg });
        setActionMessage({ type: 'error', text: `❌ ${errorMsg}` });
      }
    } catch (err) {
      console.error("Error sending reminder email:", err);
      const connErrMsg = 'Error connecting to email service.';
      setReminderFeedback({ type: 'error', text: connErrMsg });
      setActionMessage({ type: 'error', text: `❌ ${connErrMsg}` });
    } finally {
      setSendingReminder(false);
      setTimeout(() => setReminderFeedback(null), 8000);
      setTimeout(() => setActionMessage(null), 8000);
    }
  };

  // 7. SEND BULK REMINDER TO ALL EXISTING EMPLOYEES WITH PENDING DOCUMENTS
  const handleBulkReminder = async () => {
    if (!isManagement || bulkSending) return;

    const confirmSend = window.confirm(
      "Are you sure you want to send official reminder emails to ALL existing employees who have pending documents?\n\nEach employee will receive an email listing their specific pending documents and submission deadline."
    );
    if (!confirmSend) return;

    setBulkSending(true);
    setBulkSuccess(false);
    const initialBulkMsg = 'Sending document reminder emails to existing employees...';
    setBulkFeedback({ type: 'loading', text: initialBulkMsg });
    setActionMessage({ type: 'info', text: `⏳ ${initialBulkMsg}` });

    try {
      const res = await fetch(`${DOCS_API_BASE}/send_bulk_existing_reminders.php`);
      const result = await res.json();

      if (result.success) {
        setBulkSuccess(true);
        const successMsg = result.message || 'Bulk reminder emails sent successfully!';
        setBulkFeedback({ type: 'success', text: successMsg });
        setActionMessage({ type: 'success', text: `✅ ${successMsg}` });
        fetchAllEmployees();
        if (targetEmpId) {
          fetchEmployeeDocuments(targetEmpId);
        }
        setTimeout(() => setBulkSuccess(false), 5000);
      } else {
        const errorMsg = result.message || 'Failed to send bulk reminder emails.';
        setBulkFeedback({ type: 'error', text: errorMsg });
        setActionMessage({ type: 'error', text: `❌ ${errorMsg}` });
      }
    } catch (err) {
      console.error("Bulk reminder error:", err);
      const connErrMsg = 'Server error while sending bulk reminder emails.';
      setBulkFeedback({ type: 'error', text: connErrMsg });
      setActionMessage({ type: 'error', text: `❌ ${connErrMsg}` });
    } finally {
      setBulkSending(false);
      setTimeout(() => setBulkFeedback(null), 9000);
      setTimeout(() => setActionMessage(null), 9000);
    }
  };

  // Filtered employees list for Management dropdown/search
  const filteredEmployees = useMemo(() => {
    if (!searchQuery.trim()) return employeesList;
    const q = searchQuery.toLowerCase();
    return employeesList.filter(e =>
      e.emp_name?.toLowerCase().includes(q) ||
      e.emp_id?.toString().toLowerCase().includes(q) ||
      e.department?.toLowerCase().includes(q)
    );
  }, [employeesList, searchQuery]);

  // Available departments list (matching RnU module reference)
  const availableDepartments = useMemo(() => {
    const depts = new Set();
    employeesList.forEach(e => {
      if (e.department && String(e.department).trim()) {
        depts.add(String(e.department).trim());
      }
    });
    return ["All", ...Array.from(depts).sort((a, b) => a.localeCompare(b))];
  }, [employeesList]);

  // Matrix employees filtered by selected department
  const matrixDeptEmployees = useMemo(() => {
    if (!departmentFilter || departmentFilter === 'All') return employeesList;
    return employeesList.filter(e => (e.department || '').trim().toLowerCase() === departmentFilter.trim().toLowerCase());
  }, [employeesList, departmentFilter]);

  // Filtered employees list for Page 1 Compliance Matrix
  const filteredMatrixEmployees = useMemo(() => {
    let list = matrixDeptEmployees;

    // Filter tab
    if (matrixFilter === 'pending') {
      list = list.filter(e => Number(e.missing_count) > 0);
    } else if (matrixFilter === 'compliant') {
      list = list.filter(e => Number(e.missing_count) === 0);
    } else if (matrixFilter === 'overdue') {
      list = list.filter(e => e.is_overdue || e.is_locked);
    }

    // Search query
    if (matrixSearch.trim()) {
      const q = matrixSearch.toLowerCase();
      list = list.filter(e =>
        e.emp_name?.toLowerCase().includes(q) ||
        e.emp_id?.toString().toLowerCase().includes(q) ||
        e.department?.toLowerCase().includes(q)
      );
    }

    return list;
  }, [matrixDeptEmployees, matrixFilter, matrixSearch]);

  // Currently selected employee object
  const selectedEmployeeObj = useMemo(() => {
    return employeesList.find(e => String(e.emp_id) === String(selectedEmpId)) || null;
  }, [employeesList, selectedEmpId]);

  // Close custom dropdown on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
        setSearchQuery('');
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  // Management Stats Calculations (Overall)
  const stats = useMemo(() => {
    const total = employeesList.length;
    const compliant = employeesList.filter(e => e.missing_count === 0).length;
    const incomplete = employeesList.filter(e => e.missing_count > 0).length;
    const overdue = employeesList.filter(e => e.is_overdue || e.is_locked).length;
    return { total, compliant, incomplete, overdue };
  }, [employeesList]);

  // Matrix Toolbar Filter Pill Counts (Dynamic based on selected department)
  const matrixStats = useMemo(() => {
    const total = matrixDeptEmployees.length;
    const compliant = matrixDeptEmployees.filter(e => Number(e.missing_count) === 0).length;
    const incomplete = matrixDeptEmployees.filter(e => Number(e.missing_count) > 0).length;
    const overdue = matrixDeptEmployees.filter(e => e.is_overdue || e.is_locked).length;
    return { total, compliant, incomplete, overdue };
  }, [matrixDeptEmployees]);

  const completionPercent = empData ? Math.round((empData.submitted_count / empData.total_required) * 100) : 0;

  // Format date and time (e.g. "15 Oct 2026, 11:30 PM")
  const formatDueDateTime = (dateStr) => {
    if (!dateStr) return '';
    const cleanStr = String(dateStr).trim().replace(' ', 'T');
    const d = new Date(cleanStr);
    if (isNaN(d.getTime())) return dateStr;
    const hasTime = dateStr.includes(':') || cleanStr.includes('T');
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      ...(hasTime ? { hour: '2-digit', minute: '2-digit', hour12: true } : {})
    });
  };

  return (
    <div className={`documents-container ${isLightMode ? 'light-theme light-mode' : 'dark-theme'} animate-fade`}>
      <div className="docs-hub-card">

        {/* --- HEADER --- */}
        <div className="docs-header">
          <div className="docs-header-left">
            <div className="docs-icon-badge">📁</div>
            <div>
              <h2 className="docs-title">
                {isManagement
                  ? (viewMode === 'matrix' ? "EMPLOYEE_COMPLIANCE_MATRIX" : "EMPLOYEE_DOCUMENT_HUB")
                  : "MANDATORY_DOCUMENT_VAULT"}
              </h2>
              <div className="docs-subtitle">
                {isManagement
                  ? (viewMode === 'matrix'
                    ? "Real-time compliance checklist of all employees across all 11 mandatory onboarding documents"
                    : "Track mandatory employee onboarding documentation, review submissions, and manage system access")
                  : "Submit required company onboarding documents to maintain active dashboard access"}
              </div>
            </div>
          </div>

          {actionMessage && (
            <div className={`docs-toast-alert ${actionMessage.type}`}>
              {actionMessage.text}
            </div>
          )}
        </div>

        {/* FLOATING TOAST NOTIFICATION (ALWAYS VISIBLE REGARDLESS OF SCROLL) */}
        {actionMessage && (
          <div className={`docs-floating-toast ${actionMessage.type} animate-slide-down`}>
            <span className="toast-icon">
              {actionMessage.type === 'success' ? '✅' : actionMessage.type === 'error' ? '❌' : '⏳'}
            </span>
            <span className="toast-text">{actionMessage.text}</span>
            <button
              type="button"
              className="toast-close-btn"
              onClick={() => setActionMessage(null)}
              aria-label="Close message"
            >
              ✕
            </button>
          </div>
        )}

        {/* --- MANAGEMENT VIEW SWITCHER BAR (PAGE 1 vs PAGE 2 TABS) --- */}
        {isManagement && (
          <div className="docs-view-switcher-bar">
            <div className="docs-view-tabs">
              <button
                type="button"
                className={`docs-view-tab ${viewMode === 'matrix' ? 'active' : ''}`}
                onClick={() => setViewMode('matrix')}
              >
                <span className="tab-icon">📊</span>
                <span className="tab-title">ALL EMPLOYEES MATRIX</span>
                <span className="tab-badge">{employeesList.length}</span>
              </button>

              <button
                type="button"
                className={`docs-view-tab ${viewMode === 'detail' ? 'active' : ''}`}
                onClick={() => setViewMode('detail')}
              >
                <span className="tab-icon">👤</span>
                <span className="tab-title">INDIVIDUAL WORKSPACE</span>
                {selectedEmployeeObj ? (
                  <span className="tab-subtext">— {selectedEmployeeObj.emp_name}</span>
                ) : (
                  <span className="tab-subtext">— (Select Employee)</span>
                )}
              </button>
            </div>

            {viewMode === 'detail' && (
              <button
                type="button"
                className="btn-back-matrix"
                onClick={handleBackToMatrix}
                title="Return to compliance matrix overview"
              >
                <span className="btn-back-icon">←</span>
                <span>Back to All Employees Matrix</span>
              </button>
            )}
          </div>
        )}

        {/* ========================================================
            PAGE 1: ALL EMPLOYEES COMPLIANCE MATRIX (MANAGEMENT)
            (Compact Single-Page Layout - Zero Horizontal Scroll)
            ======================================================== */}
        {isManagement && viewMode === 'matrix' && (
          <div className="matrix-page-view compact-page-view animate-fade">
            {/* COMPACT TOOLBAR (SEARCH + DEPT FILTER - RIGHT ALIGNED) */}
            <div className="matrix-toolbar-compact">
              <div className="matrix-toolbar-right">
                <div className="matrix-search-box-compact">
                  <span className="matrix-search-icon">🔍</span>
                  <input
                    type="text"
                    className="matrix-search-input-compact"
                    placeholder="Search by name, ID or department..."
                    value={matrixSearch}
                    onChange={(e) => setMatrixSearch(e.target.value)}
                  />
                  {matrixSearch && (
                    <button
                      type="button"
                      className="matrix-search-clear"
                      onClick={() => setMatrixSearch('')}
                      title="Clear search"
                    >
                      ✕
                    </button>
                  )}
                </div>

                {/* DEPARTMENT FILTER (POLICY RNU REFERENCE) */}
                <div className="matrix-dept-filter-wrap">
                  <select
                    value={departmentFilter}
                    onChange={(e) => setDepartmentFilter(e.target.value)}
                    className="matrix-dept-select"
                    title="Filter employees by department"
                  >
                    {availableDepartments.map((dept, index) => (
                      <option key={index} value={dept}>
                        {dept === 'All' ? 'All Departments' : dept}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* <div className="matrix-filters-compact">
                <button
                  type="button"
                  className={`matrix-filter-pill-compact ${matrixFilter === 'all' ? 'active' : ''}`}
                  onClick={() => setMatrixFilter('all')}
                >
                  All ({matrixStats.total})
                </button>
                <button
                  type="button"
                  className={`matrix-filter-pill-compact pending ${matrixFilter === 'pending' ? 'active' : ''}`}
                  onClick={() => setMatrixFilter('pending')}
                >
                  Pending ({matrixStats.incomplete})
                </button>
                <button
                  type="button"
                  className={`matrix-filter-pill-compact compliant ${matrixFilter === 'compliant' ? 'active' : ''}`}
                  onClick={() => setMatrixFilter('compliant')}
                >
                  Compliant ({matrixStats.compliant})
                </button>
                <button
                  type="button"
                  className={`matrix-filter-pill-compact overdue ${matrixFilter === 'overdue' ? 'active' : ''}`}
                  onClick={() => setMatrixFilter('overdue')}
                >
                  Restricted ({matrixStats.overdue})
                </button>
                <button
                  type="button"
                  className="matrix-btn-refresh-compact"
                  onClick={fetchAllEmployees}
                  title="Reload employee matrix"
                  disabled={mgmtLoading}
                >
                  {mgmtLoading ? "⏳" : "🔄 Refresh"}
                </button>
              </div> */}
            </div>

            {/* 11-DOCUMENT COMPLIANCE MATRIX TABLE (100% WIDTH FIT, ZERO SCROLL) */}
            <div className="doc-matrix-table-card compact-matrix-card">
              <div className="doc-matrix-table-wrap compact-matrix-wrap">
                <table className="doc-matrix-table compact-matrix-table">
                  <colgroup>
                    <col style={{ width: '14%' }} />
                    {MATRIX_COLUMNS.map(col => (
                      <col key={col.slot} style={{ width: '7%' }} />
                    ))}
                    <col style={{ width: '9%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="matrix-th-emp compact-th">EMPLOYEE NAME</th>
                      {MATRIX_COLUMNS.map((col) => (
                        <th
                          key={col.slot}
                          className="matrix-th-doc compact-th"
                          style={{ textAlign: 'center', verticalAlign: 'middle' }}
                          title={col.docType}
                        >
                          <div className="compact-header-label" style={{ textAlign: 'center', margin: '0 auto', width: '100%' }}>
                            {col.label}
                          </div>
                        </th>
                      ))}
                      <th className="matrix-th-action compact-th" style={{ textAlign: 'center', verticalAlign: 'middle' }}>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mgmtLoading && employeesList.length === 0 ? (
                      <tr>
                        <td colSpan={MATRIX_COLUMNS.length + 2} className="doc-loading-cell compact-td">
                          <span className="doc-inline-spinner" aria-hidden="true"></span>
                          <span style={{ marginLeft: '8px' }}>Loading employee compliance matrix...</span>
                        </td>
                      </tr>
                    ) : filteredMatrixEmployees.length === 0 ? (
                      <tr>
                        <td colSpan={MATRIX_COLUMNS.length + 2} className="doc-empty-prompt-cell compact-td">
                          {employeesList.length === 0
                            ? "No employees found in tblemployees."
                            : `No employees found matching filter "${matrixFilter}"${departmentFilter !== 'All' ? ` in department "${departmentFilter}"` : ''}${matrixSearch ? ` and query "${matrixSearch}"` : ''}.`}
                        </td>
                      </tr>
                    ) : (
                      filteredMatrixEmployees.map((emp) => {
                        const isLocked = Boolean(emp.is_locked);
                        const isCompliant = emp.missing_count === 0;

                        return (
                          <tr
                            key={emp.emp_id}
                            className={`matrix-row compact-row ${isLocked ? 'row-locked' : ''} ${isCompliant ? 'row-compliant' : ''}`}
                            onClick={() => handleOpenEmployeeDetail(emp.emp_id)}
                            title={`Click to open workspace for ${emp.emp_name}`}
                          >
                            {/* Column 1: EMPLOYEE NAME */}
                            <td className="matrix-td-emp compact-td">
                              <div className="matrix-emp-cell-compact">
                                <div className="matrix-emp-avatar-compact">
                                  {emp.emp_name ? emp.emp_name.charAt(0).toUpperCase() : 'E'}
                                </div>
                                <div className="matrix-emp-info-compact">
                                  <div className="matrix-emp-name-compact" title={emp.emp_name}>
                                    <span>{emp.emp_name}</span>
                                    {isLocked && <span className="matrix-locked-pill-compact">LOCKED</span>}
                                  </div>
                                  <div className="matrix-emp-dept-compact" title={emp.department || 'General'}>
                                    {emp.department || 'General'}
                                  </div>
                                </div>
                              </div>
                            </td>

                            {/* Columns 2-11: 10 MANDATORY DOCUMENT STATUS BADGES */}
                            {MATRIX_COLUMNS.map((col) => {
                              const doc = (emp.documents || []).find(
                                d => d.slot_number === col.slot || d.doc_type === col.docType
                              );
                              const isSubmitted = Boolean(doc && (doc.is_submitted || doc.status === 'Submitted'));

                              return (
                                <td
                                  key={col.slot}
                                  className="matrix-td-status compact-td"
                                  style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                  title={`${emp.emp_name} • ${col.label}\nStatus: ${isSubmitted ? 'SUBMITTED' : 'PENDING'}${doc?.file_name ? `\nFile: ${doc.file_name}` : ''}${doc?.uploaded_by ? `\nUploaded By: ${doc.uploaded_by}` : ''}`}
                                >
                                  {isSubmitted ? (
                                    <div className="matrix-badge-compact matrix-badge-submitted" aria-label="Submitted">
                                      ✓
                                    </div>
                                  ) : (
                                    <div className="matrix-badge-compact matrix-badge-pending" aria-label="Pending">
                                      ✕
                                    </div>
                                  )}
                                </td>
                              );
                            })}

                            {/* Column 12: PROGRESS & ACTION BUTTON */}
                            <td className="matrix-td-action compact-td" style={{ textAlign: 'center', verticalAlign: 'middle' }} onClick={(e) => e.stopPropagation()}>
                              <div className="matrix-action-cell-compact">
                                <span className={`matrix-count-badge-compact ${isCompliant ? 'full' : 'pending'}`}>
                                  {emp.submitted_count}/10
                                </span>
                                <button
                                  type="button"
                                  className="btn-matrix-open-compact"
                                  onClick={() => handleOpenEmployeeDetail(emp.emp_id)}
                                  title={`Open ${emp.emp_name}'s document workspace`}
                                >
                                  <span className="btn-matrix-text">Manage</span>
                                  <span className="btn-matrix-arrow">→</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* ========================================================
            PAGE 2: INDIVIDUAL EMPLOYEE WORKSPACE
            (Shown when regular employee OR when viewMode === 'detail')
            ======================================================== */}
        {(!isManagement || viewMode === 'detail') && (
          <div className="detail-page-view animate-fade">

            {/* MANAGEMENT SECTION: STATS & EMPLOYEE SELECTOR */}
            {isManagement && (
              <>
                {/* KPI STATS CARDS */}
                <div className="docs-stats-grid">
                  <div className="docs-stat-card">
                    <div className="docs-stat-label">Total Monitored</div>
                    <div className="docs-stat-value">{stats.total}</div>
                  </div>
                  <div className="docs-stat-card compliant">
                    <div className="docs-stat-label">Fully Compliant (10/10)</div>
                    <div className="docs-stat-value">{stats.compliant}</div>
                  </div>
                  <div className="docs-stat-card pending">
                    <div className="docs-stat-label">Pending Submissions</div>
                    <div className="docs-stat-value">{stats.incomplete}</div>
                  </div>
                  <div className="docs-stat-card overdue">
                    <div className="docs-stat-label">Overdue / Restricted</div>
                    <div className="docs-stat-value">{stats.overdue}</div>
                  </div>
                </div>

                {/* 📢 BULK ACTION BAR FOR EXISTING EMPLOYEES */}
                <div className="bulk-reminder-card">
                  <div>
                    <div className="bulk-reminder-title">
                      <span>📢</span> NOTIFY ALL EXISTING EMPLOYEES WITH PENDING DOCUMENTS
                    </div>
                    <div className="bulk-reminder-desc">
                      Click this button to trigger an official reminder email to all existing employees who have not yet submitted all 10 mandatory documents.
                    </div>
                  </div>

                  <div className="bulk-btn-wrapper">
                    <button
                      type="button"
                      className={`btn-bulk-reminder ${bulkSending ? 'is-loading' : ''} ${bulkSuccess ? 'is-success' : ''}`}
                      disabled={bulkSending || stats.incomplete === 0}
                      onClick={handleBulkReminder}
                    >
                      {bulkSending ? (
                        <>
                          <span className="doc-btn-spinner" aria-hidden="true"></span>
                          <span>Sending Emails...</span>
                        </>
                      ) : bulkSuccess ? (
                        <>
                          <span>✅</span>
                          <span>Emails Sent Successfully!</span>
                        </>
                      ) : (
                        <span>✉️ Send Email to All Existing Employees ({stats.incomplete} Pending)</span>
                      )}
                    </button>

                    {bulkFeedback && (
                      <div className={`bulk-action-feedback ${bulkFeedback.type} animate-fade`}>
                        {bulkFeedback.type === 'loading' && <span className="doc-inline-spinner" aria-hidden="true"></span>}
                        {bulkFeedback.type === 'success' && <span className="feedback-icon">✅</span>}
                        {bulkFeedback.type === 'error' && <span className="feedback-icon">❌</span>}
                        <span className="feedback-text">{bulkFeedback.text}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* EMPLOYEE SELECTOR */}
                <div className={`emp-selector-panel ${isDropdownOpen ? 'dropdown-active' : ''}`} style={{ position: 'relative', zIndex: isDropdownOpen ? 10000 : 1 }}>
                  <label className="emp-selector-label">
                    SELECT EMPLOYEE TO MANAGE DOCUMENTS
                  </label>
                  <div className="emp-selector-row" style={{ marginTop: '10px' }}>
                    <div className="emp-select-box" ref={dropdownRef} style={{ flex: '1', position: 'relative', zIndex: isDropdownOpen ? 10001 : 1 }}>
                      {/* SINGLE UNIFIED SEARCHABLE DROPDOWN FIELD (NO TWO FIELDS) */}
                      <div
                        className={`emp-combobox-field ${isDropdownOpen ? 'open' : ''}`}
                        onClick={() => {
                          if (!isDropdownOpen) {
                            setIsDropdownOpen(true);
                          }
                          searchInputRef.current?.focus();
                        }}
                        role="combobox"
                        aria-expanded={isDropdownOpen}
                      >
                        <span className="emp-combobox-icon">🔍</span>

                        <input
                          ref={searchInputRef}
                          type="text"
                          className="emp-combobox-input"
                          value={isDropdownOpen ? searchQuery : (selectedEmployeeObj ? `${selectedEmployeeObj.emp_name} (${selectedEmployeeObj.emp_id}) — ${selectedEmployeeObj.department || 'General'}` : '')}
                          placeholder={
                            isDropdownOpen
                              ? (selectedEmployeeObj ? `Type to search (Current: ${selectedEmployeeObj.emp_name})...` : "Type to filter by name, ID or department...")
                              : "Select employee to manage documents..."
                          }
                          onChange={(e) => {
                            setSearchQuery(e.target.value);
                            if (!isDropdownOpen) setIsDropdownOpen(true);
                          }}
                          onFocus={() => {
                            setIsDropdownOpen(true);
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsDropdownOpen(true);
                          }}
                        />

                        {/* Meta info tags when closed or not searching */}
                        {selectedEmployeeObj && !searchQuery && (
                          <div className="emp-combobox-meta">
                            <span className="emp-count-pill">[{selectedEmployeeObj.submitted_count}/10 Docs]</span>
                            {selectedEmployeeObj.is_locked && <span className="emp-lock-warning">⚠️ LOCKED</span>}
                          </div>
                        )}

                        {/* Clear search button if typed */}
                        {searchQuery && (
                          <button
                            type="button"
                            className="emp-combobox-clear-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchQuery('');
                              searchInputRef.current?.focus();
                            }}
                            title="Clear filter"
                          >
                            ✕
                          </button>
                        )}

                        {/* Dropdown chevron toggle */}
                        <span
                          className={`emp-arrow ${isDropdownOpen ? 'rotated' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsDropdownOpen(prev => {
                              const nextState = !prev;
                              if (nextState) {
                                setTimeout(() => searchInputRef.current?.focus(), 50);
                              } else {
                                setSearchQuery('');
                              }
                              return nextState;
                            });
                          }}
                          role="button"
                          tabIndex={0}
                        >
                          ▼
                        </span>
                      </div>

                      {/* ⬇️ STRICTLY DOWNWARD OPENING DROPDOWN MENU ⬇️ */}
                      {isDropdownOpen && (
                        <div className="emp-downward-menu animate-fade">
                          {filteredEmployees.length === 0 ? (
                            <div className="emp-option-empty">
                              No employees found matching "{searchQuery}"
                            </div>
                          ) : (
                            filteredEmployees.map(emp => {
                              const isSelected = String(emp.emp_id) === String(selectedEmpId);
                              return (
                                <div
                                  key={emp.emp_id}
                                  className={`emp-custom-option ${isSelected ? 'active' : ''}`}
                                  onClick={() => {
                                    setSelectedEmpId(emp.emp_id);
                                    setIsDropdownOpen(false);
                                  }}
                                >
                                  <div className="emp-option-left">
                                    <div className="emp-opt-avatar">
                                      {emp.emp_name?.charAt(0) || "E"}
                                    </div>
                                    <div className="emp-opt-info">
                                      <div className="emp-opt-name">
                                        {emp.emp_name} <span className="emp-opt-id">({emp.emp_id})</span>
                                      </div>
                                      <div className="emp-opt-dept">{emp.department || 'General'}</div>
                                    </div>
                                  </div>

                                  <div className="emp-option-right">
                                    <span className={`emp-opt-badge ${emp.missing_count === 0 ? 'full' : 'pending'}`}>
                                      {emp.submitted_count}/10 Docs
                                    </span>
                                    {emp.is_locked && <span className="emp-opt-locked">⚠️ LOCKED</span>}
                                    {isSelected && <span className="emp-opt-check">✓</span>}
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* ========================================================
                ACTIVE EMPLOYEE PROFILE & COMPLIANCE BANNER
                ======================================================== */}
            {empData && (
              <div className="selected-emp-banner">
                <div className="emp-profile-info">
                  <div className="emp-avatar">
                    {empData.emp_name?.charAt(0) || "E"}
                  </div>
                  <div className="emp-details-text">
                    <h3>{empData.emp_name}</h3>
                    <div className="emp-meta-pills">
                      <span className="pill-tag">ID: {empData.emp_id}</span>
                      {empData.department && <span className="pill-tag">Dept: {empData.department}</span>}
                      <span className="pill-tag due">
                        Due: {formatDueDateTime(empData.due_date)}
                      </span>

                      {empData.is_locked ? (
                        <span className="pill-tag locked">🚫 ACCESS RESTRICTED</span>
                      ) : empData.manually_unlocked ? (
                        <span className="pill-tag unlocked">🔓 MANUALLY UNLOCKED</span>
                      ) : empData.missing_count === 0 ? (
                        <span className="pill-tag unlocked">✓ FULLY COMPLIANT</span>
                      ) : (
                        <span className="pill-tag due">PENDING SUBMISSION</span>
                      )}

                      {empData.last_reminder_sent && (
                        <span className="pill-tag reminder-info" title="Timestamp of last sent reminder email">
                          ✉️ Last Reminded: {new Date(empData.last_reminder_sent).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* MANAGEMENT ACTION CONTROLS */}
                {isManagement && (
                  <div className="emp-actions-wrapper">
                    <div className="emp-actions-group">
                      <button
                        type="button"
                        className={`btn-lock-toggle ${empData.is_locked ? 'unlock-mode' : 'lock-mode'}`}
                        onClick={handleToggleLock}
                      >
                        {empData.is_locked ? "🔓 Unlock Access" : "🔒 Restrict Access"}
                      </button>

                      <button
                        type="button"
                        className={`btn-reminder-email ${sendingReminder ? 'is-loading' : ''} ${reminderSuccess ? 'is-success' : ''}`}
                        onClick={handleSendReminder}
                        disabled={empData.missing_count === 0 || sendingReminder}
                      >
                        {sendingReminder ? (
                          <>
                            <span className="doc-btn-spinner" aria-hidden="true"></span>
                            <span>Sending Email...</span>
                          </>
                        ) : reminderSuccess ? (
                          <>
                            <span>✅</span>
                            <span>Email Sent!</span>
                          </>
                        ) : (
                          <>
                            <span>✉️</span>
                            <span>Send Reminder Email</span>
                          </>
                        )}
                      </button>
                    </div>

                    {/* INLINE STATUS / LOADER FEEDBACK RIGHT AT THE BUTTON */}
                    {reminderFeedback && (
                      <div className={`emp-action-feedback ${reminderFeedback.type} animate-fade`}>
                        {reminderFeedback.type === 'loading' && <span className="doc-inline-spinner" aria-hidden="true"></span>}
                        {reminderFeedback.type === 'success' && <span className="feedback-icon">✅</span>}
                        {reminderFeedback.type === 'error' && <span className="feedback-icon">❌</span>}
                        <span className="feedback-text">{reminderFeedback.text}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* ========================================================
                COUNTDOWN TIMER BANNER (SHOWN TO BOTH OR EMPLOYEE)
                ======================================================== */}
            {empData && (
              <div className={`countdown-banner ${empData.is_overdue ? 'overdue-mode' : ''}`}>
                <div className="countdown-title-area">
                  <h3>
                    {empData.is_overdue
                      ? "⚠️ DOCUMENT DEADLINE EXPIRED"
                      : empData.is_existing_employee
                        ? "📅 EXISTING EMPLOYEE SUBMISSION DEADLINE"
                        : "⏳ 6-WEEKS ONBOARDING COMPLIANCE WINDOW"}
                  </h3>
                  <p>
                    {empData.is_overdue
                      ? "Submission deadline was " + formatDueDateTime(empData.due_date) + ". Mandatory documents must be submitted immediately."
                      : "All 11 mandatory documents must be uploaded before deadline (" + formatDueDateTime(empData.due_date) + ") to maintain dashboard access."}
                  </p>
                </div>

                <div className="timer-units-row">
                  <div className="timer-box">
                    <div className="timer-val">{String(timeLeft.days).padStart(2, '0')}</div>
                    <div className="timer-lbl">Days</div>
                  </div>
                  <div className="timer-box">
                    <div className="timer-val">{String(timeLeft.hours).padStart(2, '0')}</div>
                    <div className="timer-lbl">Hours</div>
                  </div>
                  <div className="timer-box">
                    <div className="timer-val">{String(timeLeft.minutes).padStart(2, '0')}</div>
                    <div className="timer-lbl">Mins</div>
                  </div>
                  <div className="timer-box">
                    <div className="timer-val">{String(timeLeft.seconds).padStart(2, '0')}</div>
                    <div className="timer-lbl">Secs</div>
                  </div>
                </div>
              </div>
            )}

            {/* PROGRESS BAR */}
            {empData && (
              <div className="compliance-progress-wrap">
                <div className="progress-labels">
                  <span>DOCUMENT SUBMISSION PROGRESS</span>
                  <span>{empData.submitted_count} of {empData.total_required} Submitted ({completionPercent}%)</span>
                </div>
                <div className="progress-bar-track">
                  <div className="progress-bar-fill" style={{ width: `${completionPercent}%` }}></div>
                </div>
              </div>
            )}

            {/* ========================================================
                10 MANDATORY DOCUMENTS CHECKLIST TABLE
                ======================================================== */}
            <div className="docs-table-container">
              <table className="docs-custom-table">
                <thead>
                  <tr>
                    <th className="doc-th-num" style={{ width: '45px', textAlign: 'center' }}>#</th>
                    <th className="doc-th-type" style={{ width: '25%', minWidth: '200px' }}>REQUIRED DOCUMENT TYPE</th>
                    <th className="doc-th-status" style={{ width: '155px' }}>STATUS</th>
                    <th className="doc-th-info" style={{ width: '190px' }}>UPLOADED FILE INFO</th>
                    <th className="doc-th-action" style={{ textAlign: 'right', minWidth: '380px' }}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingDocs ? (
                    <tr>
                      <td colSpan="5" className="doc-loading-cell">
                        Loading documents...
                      </td>
                    </tr>
                  ) : (!empData && isManagement) ? (
                    <tr>
                      <td colSpan="5" className="doc-empty-prompt-cell">
                        👉 Please select an employee from the dropdown above or switch to the <b>All Employees Matrix</b> tab to pick an employee.
                      </td>
                    </tr>
                  ) : documents.map((doc, idx) => {
                    const isSubmitted = doc.status === 'Submitted';
                    const isBusyUploading = uploadingDocType === doc.doc_type;
                    const isToggling = togglingDocType === doc.doc_type;
                    const hasPhysicalFile = Boolean(doc.file_path && doc.file_path.trim() !== '');

                    return (
                      <tr key={doc.doc_type || idx} className={isSubmitted ? "row-submitted" : "row-pending"}>
                        {/* Number Badge */}
                        <td className="doc-td-num">
                          <div className="doc-num-badge">{idx + 1}</div>
                        </td>

                        {/* Document Title */}
                        <td className="doc-td-type">
                          <div className="doc-name-cell">
                            <div>
                              <div className="doc-name-title">{doc.doc_type}</div>
                              {isSubmitted && hasPhysicalFile && (
                                <div className="doc-file-info">
                                  📄 {doc.file_name} • {doc.file_size || ''}
                                </div>
                              )}
                              {isSubmitted && !hasPhysicalFile && (
                                <div className="doc-file-info doc-verified-info">
                                  ✓ Verified without file upload
                                </div>
                              )}
                            </div>
                          </div>
                        </td>

                        {/* Status Badge & Tickmark */}
                        <td className="doc-td-status">
                          {isManagement ? (
                            <label
                              className={`mgmt-doc-toggle-wrap ${isSubmitted ? 'is-submitted' : 'is-pending'}`}
                              title={isSubmitted ? "Click tickmark to revert to Pending" : "Click tickmark to mark as Submitted"}
                            >
                              <input
                                type="checkbox"
                                className="mgmt-doc-checkbox"
                                checked={isSubmitted}
                                disabled={isToggling || isBusyUploading}
                                onChange={() => handleToggleDocSubmission(doc.doc_type, isSubmitted)}
                              />
                              <span className="mgmt-doc-custom-check">
                                {isToggling ? "⏳" : isSubmitted ? "✓" : ""}
                              </span>
                              <span className={`badge-status ${isSubmitted ? 'submitted' : 'pending'}`}>
                                {isSubmitted ? "✓ SUBMITTED" : "PENDING"}
                              </span>
                            </label>
                          ) : (
                            <span className={`badge-status ${isSubmitted ? 'submitted' : 'pending'}`}>
                              {isSubmitted ? "✓ SUBMITTED" : "PENDING"}
                            </span>
                          )}
                        </td>

                        {/* File Metadata */}
                        <td className="doc-td-info">
                          {isSubmitted ? (
                            <div className="doc-meta-info">
                              <div>
                                {hasPhysicalFile ? "By: " : "Verified By: "}
                                <b>{doc.uploaded_by || 'Management'}</b>
                              </div>
                              <div className="doc-meta-date">
                                {doc.uploaded_at ? new Date(doc.uploaded_at).toLocaleDateString('en-GB') : ''}
                                {!hasPhysicalFile && " • Verified"}
                              </div>
                            </div>
                          ) : (
                            <span className="doc-awaiting-text">
                              {isManagement ? "Awaiting upload or tick mark" : "Awaiting file upload"}
                            </span>
                          )}
                        </td>

                        {/* Actions */}
                        <td className="doc-td-action" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                          <div className="doc-action-btns" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}>
                            {/* 1. If Submitted */}
                            {isSubmitted && (
                              <>
                                {hasPhysicalFile && doc.file_url && (
                                  <a
                                    href={doc.file_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn-doc-view"
                                    title="Preview document in browser"
                                  >
                                    👁️ VIEW
                                  </a>
                                )}

                                {hasPhysicalFile && (
                                  <a
                                    href={doc.download_url || `${DOCS_API_BASE}/download_doc.php?id=${doc.doc_id || ''}&path=${encodeURIComponent(doc.file_path || '')}`}
                                    className="btn-doc-download"
                                    title={`Download ${doc.file_name || doc.doc_type}`}
                                    download={doc.file_name || doc.doc_type}
                                  >
                                    ⬇️ DOWNLOAD
                                  </a>
                                )}

                                {/* Management can replace file if file exists, or attach file if only ticked */}
                                {isManagement && (
                                  <label className={hasPhysicalFile ? "btn-doc-replace" : "btn-doc-upload"} style={{ cursor: 'pointer' }}>
                                    {isBusyUploading ? "Uploading..." : (hasPhysicalFile ? "🔄 Replace" : "⬆️ Attach File")}
                                    <input
                                      type="file"
                                      hidden
                                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                      disabled={isBusyUploading || isToggling}
                                      onChange={(e) => {
                                        if (e.target.files[0]) {
                                          handleFileUpload(doc.doc_type, e.target.files[0]);
                                          e.target.value = null;
                                        }
                                      }}
                                    />
                                  </label>
                                )}

                                {/* Management can unmark/revert to pending */}
                                {isManagement && (
                                  <button
                                    type="button"
                                    className="btn-doc-unmark"
                                    title="Revert to pending"
                                    disabled={isToggling || isBusyUploading}
                                    onClick={() => handleToggleDocSubmission(doc.doc_type, true)}
                                  >
                                    {isToggling ? "..." : "✕ Unmark"}
                                  </button>
                                )}
                              </>
                            )}

                            {/* 2. If Pending */}
                            {!isSubmitted && (
                              <>
                                {/* Management Quick Tickmark Button */}
                                {isManagement && (
                                  <button
                                    type="button"
                                    className="btn-doc-tick"
                                    title="Mark this document as submitted without uploading a file"
                                    disabled={isToggling || isBusyUploading}
                                    onClick={() => handleToggleDocSubmission(doc.doc_type, false)}
                                  >
                                    {isToggling ? (
                                      <>
                                        <span className="doc-btn-spinner" aria-hidden="true"></span>
                                        <span>Saving...</span>
                                      </>
                                    ) : (
                                      <span>✓ Tick Mark</span>
                                    )}
                                  </button>
                                )}

                                {/* Upload file button (available to both management and employee) */}
                                <label className="btn-doc-upload">
                                  {isBusyUploading ? "Uploading..." : (isManagement ? "⬆️ Upload Doc" : "⬆️ Upload File")}
                                  <input
                                    type="file"
                                    hidden
                                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                    disabled={isBusyUploading || isToggling}
                                    onChange={(e) => {
                                      if (e.target.files[0]) {
                                        handleFileUpload(doc.doc_type, e.target.files[0]);
                                        e.target.value = null;
                                      }
                                    }}
                                  />
                                </label>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Documents;